<template>
  <div class="page_empRosterPerson">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="110px">
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.projectid" placeholder="" size="small" style="width: 180px;" filterable clearable @change="getList">
                <el-option label="全部" :value="0"></el-option>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.strEmpName" size="small" placeholder="" clearable style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="身份证" size="small">
              <el-input v-model="listQuery.strIdCard" size="small" placeholder="" clearable style="width: 180px;"></el-input>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="getList" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box" style="padding-left: 27px">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="111px">
          <el-form-item label="联系方式:">
            <el-input v-model="listQuery.strPhoneNum" size="small" clearable placeholder="" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="临时工:">
            <el-select v-model="listQuery.strOther" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄:" v-if="activeName != '离职'">
            <div class="flex">
              <el-input v-model="ageStart" size="small" clearable placeholder="" style="width: 75px;"></el-input>
              <div style="margin: 0 10px;">~</div>
              <el-input v-model="ageEnd" size="small" clearable placeholder="" style="width: 75px;"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="到期提醒:" v-if="activeName != '离职'">
            <el-select v-model="listQuery.expireWarn" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option value="0" label="全部"></el-option>
              <el-option value="1" label="身份证到期"></el-option>
              <el-option value="2" label="试用期到期"></el-option>
              <el-option value="3" label="合同到期"></el-option>
              <el-option value="4" label="16周岁以下"></el-option>
              <el-option value="5" label="16~18周岁"></el-option>
              <el-option value="6" label="退休男"></el-option>
              <el-option value="7" label="退休女"></el-option>
              <el-option value="8" label="65周岁以上"></el-option>
              <el-option value="9" label="工伤纠纷"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="教育程度:" v-if="activeName != '离职'">
            <el-select v-model="listQuery.strEduLv" multiple size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option value="博士"></el-option>
              <el-option value="硕士"></el-option>
              <el-option value="本科"></el-option>
              <el-option value="大专"></el-option>
              <el-option value="中专"></el-option>
              <el-option value="高中"></el-option>
              <el-option value="初中及以下"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用工之日:">
            <div class="flex" style="width: 471px;">
              <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtEntryBdateStart" type="date" style="width:180px" placeholder="选择开始时间">
              </el-date-picker>
              <div style="margin: 0 10px;">~</div>
              <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtEntryBdateEnd" type="date" style="width:180px" placeholder="选择结束时间">
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="离职日期:" v-if="activeName == '离职'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtDepartureDateStart" type="date" style="width:180px" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="离职日期:" v-if="activeName == '离职'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtDepartureDateEnd" type="date" style="width:180px" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="合同协议类型:" v-if="activeName != '离职'">
            <el-select v-model="listQuery.strContractType" multiple size="small" style="width: 180px;" placeholder="" filterable>
              <el-option value="劳动合同"></el-option>
              <el-option value="兼职协议"></el-option>
              <el-option value="实习管理协议"></el-option>
              <el-option value="退休返聘协议"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐渠道:" prop="StrSource">
            <el-select v-model="listQuery.PushName" multiple placeholder="" style="width: 180px;" size="small" filterable clearable>
              <el-option value="宁波网招"></el-option>
              <el-option value="社招推荐人"></el-option>
              <el-option value="网招中心"></el-option>
              <el-option value="公司渠道"></el-option>
              <el-option value="校招部"></el-option>
              <el-option value="业务项目部"></el-option>
              <el-option value="招聘部"></el-option>
              <el-option value="客服部"></el-option>
              <el-option value="小杰门店"></el-option>
              <el-option value="企业转移"></el-option>
              <el-option value="员工内荐"></el-option>
              <el-option value="供应商"></el-option>
              <el-option value="其他情况"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐渠道备注:">
            <el-input v-model="listQuery.pushRemark" size="small" clearable placeholder="" style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="是否签约:" v-if="activeName != '离职'">
            <el-select v-model="listQuery.isSigning" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
              <el-option label="将到期" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否参保:" v-if="activeName != '离职'">
            <el-select v-model="listQuery.isEnrollment" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option label="全部" value="-1"></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:" v-if="activeName == '在职'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.dtInsertDate" type="date" style="width:180px" placeholder="">
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item label="参保种类" size="small">
            <el-input v-model="listQuery.StrInsuranceType" size="small" clearable style="width: 180px;"></el-input>
          </el-form-item>
          <el-form-item label="进入三方系统:">
            <el-select v-model="listQuery.IsInOtherSys" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option label="是" value="1">
              </el-option>
              <el-option label="否" value="0">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="30天内是否离职签约:">
            <el-select v-model="listQuery.isOutSign" size="small" filterable clearable placeholder="" style="width: 180px;">
              <el-option label="是" value="1">
              </el-option>
              <el-option label="否" value="0">
              </el-option>
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button size="small" type="success" @click="searchHandle">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>面试入职流程</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName }}</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>人员</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <ResourceComTabs ref="child" :active="activeName" :btnAuth="permissionLists" :listQuerys="listQuerys" @change="currChange($event)">
        </ResourceComTabs>
        <el-tabs v-if="activeName == '在职'" v-model="listQuery.isSigning" @tab-click="handleClick">
          <el-tab-pane label="全部" name="-1"></el-tab-pane>
          <el-tab-pane label="未签约" name="0"></el-tab-pane>
          <el-tab-pane label="已签约" name="1"></el-tab-pane>
          <el-tab-pane label="将到期" name="2"></el-tab-pane>
          <el-tab-pane label="流程确认入职" name="4"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2" style="margin:0 20px;" v-if="activeName == '全量'">
          <el-tab-pane label="人员" name="0"></el-tab-pane>
          <el-tab-pane label="项目" name="1"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;" class="r_act_item flex">
          <template v-if="activeName == '全量'">
            <el-button type="success" size="small" v-if="checkPermission(['tab_all_entrySign'], permissionLists)" @click="entryHandel">入职登记</el-button>
            <el-button size="small" type="warning" @click="importHandle('third')" v-if="checkPermission(['tab_all_importEntry'], permissionLists)">批量导入入职</el-button>
            <el-button size="small" class="com_btn" @click="importHandle('five')" v-if="checkPermission(['tab_all_infoMaintenance'], permissionLists)">在职信息维护</el-button>
            <el-button type="danger" size="small" v-if="checkPermission(['tab_all_quitSign'], permissionLists)" @click="quitSign">离职登记</el-button>
            <el-button size="small" class="com_btn" @click="importHandle('four')" v-if="checkPermission(['tab_all_importQuit'], permissionLists)">批量导入离职</el-button>
            <el-button type="warning" size="small" v-if="checkPermission(['tab_all_eleSign'], permissionLists)" @click="enterSignHandle">电子签约</el-button>
            <el-button size="small" type="success" v-if="checkPermission(['tab_onJob_recruiting'], permissionLists)" @click="handleInsure">批量商保增员+</el-button>
            <el-popconfirm :title="'请确认是否办理商保报减？'" v-if="checkPermission(['tab_all_reduce'], permissionLists)" @confirm="reduction('multipleSelection')" style="margin:0 10px">
              <el-button type="info" slot="reference" size="small" v-preventReClick>商保报减</el-button>
            </el-popconfirm>
            <el-button type="primary" size="small" v-if="checkPermission(['tab_all_export'], permissionLists)" :loading="isExping2" @click="expAllList">全量导出</el-button>
          </template>

          <template v-if="activeName == '在职' && (listQuery.isSigning != '4')">
            <el-button type="success" size="small" v-if="checkPermission(['tab_onJob_sign'], permissionLists)" @click="entryHandel">入职登记</el-button>
            <el-button size="small" type="primary" v-if="checkPermission(['tab_onJob_eleSign'], permissionLists)" @click="enterSignHandle">电子签约</el-button>
            <el-button type="danger" size="small" v-if="checkPermission(['tab_all_quitSign'], permissionLists)" @click="quitSign">离职登记</el-button>
            <el-popconfirm title="请确认是否办理商保报减？" v-if="checkPermission(['tab_onJob_reduction'], permissionLists)" @confirm="reduction('multipleSelection')" style="margin:0 10px">
              <el-button type="info" slot="reference" size="small" v-preventReClick>商保报减</el-button>
            </el-popconfirm>
            <el-button size="small" type="success" v-if="checkPermission(['tab_onJob_recruiting'], permissionLists)" @click="handleInsure">批量商保增员+</el-button>

            <el-button size="small" class="com_btn" @click="importHandle('thirdzz')" v-if="checkPermission(['tab_onJob_import'], permissionLists)">批量导入入职</el-button>

            <el-button size="small" class="com_btn" @click="importHandle('four')" v-if="checkPermission(['tab_onJob_importQuit'], permissionLists)">批量导入离职</el-button>
          </template>
          <template v-if="activeName == '离职'"></template>
          <el-button size="small" class="com_btn" v-if="(activeName == '在职') && (listQuery.isSigning == '4')" @click="employBatchHandle">批量处理流程入职</el-button>

          <el-button type="info" size="small" v-if="checkPermission(['tab_all_print'], permissionLists)" @click="batchPrint">批量打印</el-button>
          <el-button type="primary" size="small" v-if="checkPermission(['tab_all_export'], permissionLists)" :loading="isExping" @click="expList">导出</el-button>
        </div>
        <el-table :data="tableData" border :max-height="tableHeight < 320 ? 320 : tableHeight - 100" class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
          <el-table-column type="selection" align="center" width="45" fixed="left">
          </el-table-column>
          <!-- <el-table-column align="center" label="是否签约" prop="isSign" width="100"></el-table-column>
          <el-table-column align="center" label="是否在保" prop="isInsure" width="100"></el-table-column> -->
          <el-table-column align="center" fixed label="排序" width="50">
            <template slot-scope="{ $index }">
              <span>{{
                (Number(listQuery.pagination.page) - 1) * Number(listQuery.pagination.pageSize) + Number($index) + 1
              }}</span>
            </template>
          </el-table-column>
          <template v-for="(item, index) in filteredTableTitles">
            <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit show-overflow-tooltip :key="index" :width="item.StrColumName == '户籍地址' ||
                item.StrColumName == '现住地址' ||
                item.StrColumName == '参保日期' ||
                item.StrColumName == '签订合同起止时间记录' ||
                item.StrColumName == '备注' ? 380 : item.StrColumName == '发薪公司全称' || item.StrColumName.indexOf('公司全称') > -1 ? 280 : item.StrColumName == '姓名' ? 80 : item.StrColumName == '身份证号码' ? 160 : 140" align="center" :fixed="item.StrColumName == '项目名称' || item.StrColumName == '姓名' || item.StrColumName == '身份证号码'
                ">
              <template slot-scope="{row}">
                <div v-if="item.type == 'date'"> {{ row[item.StrColumId] ?
                  moment(row[item.StrColumId]).format('YYYY-MM-DD') : '' }} </div>
                <div v-else-if="item.type == 'referralChannels'"> {{ row[item.StrColumId] ?
                  getChannels(row[item.StrColumId]) : '' }} </div>
                <div v-else> {{ row[item.StrColumId] }}</div>
              </template>
            </el-table-column>
          </template>
          <el-table-column align="center" fixed="right" label="操作" width="180" v-if="activeName == '全量'">
            <template slot-scope="{row}">
              <div class="injuryTabBtn">
                <el-button type="text" size="small" v-if="checkPermission(['follow_up'], permissionLists)" @click="followHandle(row)">跟进</el-button>
                <el-button type="text" size="small" v-if="checkPermission(['label'], permissionLists)" @click="labelHandle(row)">标签</el-button>
                <el-button type="text" size="small" @click="editHandle(row)" v-if="checkPermission(['tab_all_edit'], permissionLists)">编辑</el-button>
                <el-button type="text" size="small" v-if="checkPermission(['tab_all_print'], permissionLists)" @click="printHandel(row)">打印</el-button>
                <!-- <el-button type="text" size="small" @click="OfflineSigning(row)">线下签约登记</el-button> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right" width="220px" class-name="re_act_box" v-if="activeName == '在职' || activeName == '离职'">
            <template slot-scope="{row}">
              <el-button v-if="checkPermission(['tab_all_eleSign'], permissionLists) && activeName == '在职' && listQuery.isSigning=='2'" type="warning" size="mini" plain @click="renew(row)">续签</el-button>
              <el-button v-if="checkPermission(['tab_onJob_edit'], permissionLists) && activeName == '在职'" type="success" size="mini" plain @click="editHandle(row)">编辑</el-button>
              <el-button v-if="activeName == '在职' && (checkPermission(['tab_resign_quit'], permissionLists))" type="danger" size="mini" @click="quitHandle(row)">离职</el-button>
              <el-button type="primary" v-if="activeName == '在职' && (checkPermission(['print'], permissionLists))" size="mini" plain @click="printHandel(row)">打印</el-button>

              <el-button type="primary" v-if="activeName == '离职' && (checkPermission(['tab_entry_entry'], permissionLists))" size="mini" plain @click="entryAgain(row)">再次入职</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pagination.page" :page-size="Number(listQuery.pagination.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 离职登记 -->
    <el-dialog title="离职登记" :visible.sync="showQuitSign" width="1100px">
      <el-form :inline="true" label-width="125px">
        <el-form-item label="离职时间">
          <el-date-picker v-model="dtDepartureDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:180px" @change="changeTurnOverTime">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际离职时间">
          <el-date-picker v-model="dtRealDepartureDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:180px" @change="changeTurnOverTimereal">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="离职类型">
          <el-select v-model="strWorkState" placeholder="" size="small" style="width:180px" @change="changeStrWorkState">
            <el-option label="正常离职" value="正常离职"></el-option>
            <el-option label="离职转正" value="离职转正"></el-option>
            <el-option label="自离" value="自离"></el-option>
            <el-option label="被辞退" value="被辞退"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="黑名单">
          <el-select v-model="isBlack" placeholder="" style="width:180px" size="small" @change="changeIsBlack" clearable>
            <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="multipleSelection" class="doc_table" v-loading="loading" style="width:100%" v-if="showQuitSign">
        <el-table-column label="姓名" prop="strEmpName" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="联系方式" prop="strPhoneNum" min-width="120" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="项目" prop="strObjName" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="岗位" prop="strJobInf" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="*离职时间" min-width="160" align="center">
          <template slot-scope="{$index}">
            <el-date-picker v-model="quitList[$index].dtDepartureDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:140px">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="*实际离职时间" min-width="160" align="center">
          <template slot-scope="{$index}">
            <el-date-picker v-model="quitList[$index].dtRealDepartureDate" type="date" value-format="yyyy-MM-dd" size="small" style="width:140px">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="*离职类型" min-width="160" align="center">
          <template slot-scope="{$index}">
            <el-select v-model="quitList[$index].strWorkState" placeholder="" size="mini" style="width:140px">
              <el-option label="正常离职" value="正常离职"></el-option>
              <el-option label="转正" value="转正"></el-option>
              <el-option label="自离" value="自离"></el-option>
              <el-option label="被辞退" value="被辞退"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="黑名单" min-width="150" align="center">
          <template slot-scope="{$index}">
            <el-select v-model="quitList[$index].strBlacklistReason" placeholder="" size="mini" clearable>
              <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="150" align="center">
          <template slot-scope="{$index}">
            <el-input v-model="quitList[$index].remark" size="small" clearable style="width:140px"></el-input>
          </template>
        </el-table-column>

      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQuitSign = false" size="small">取 消</el-button>

        <el-popconfirm title="请确认是否继续？" @confirm="confirmQuit()" style="margin-left:10px">
          <el-button type="primary" slot="reference" v-preventReClick style="margin-left:10px;" size="small" :loading="isBtnLoading">确 认</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>

    <!-- 离职后减保弹框 -->
    <el-dialog title="离职成功，减保确认" :visible.sync="showReduction" width="800px" class="res_dialog res_dialog01 enter_dialog">
      <div class="quitTips">离职成功，以下在保人员是否需商保减员？</div>
      <el-table :data="insureList" class="doc_table" style="width:100%">
        <el-table-column label="姓名" prop="strEmpName" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="联系方式" prop="strPhoneNum" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="项目" prop="strObjName" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="岗位" prop="strJobInf" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showReduction = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="reduction('insureList')" style="margin-left:10px">
          <el-button :loading="isBtnLoading" slot="reference" type="primary" class="com_dialog_btn" size="small">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>

    <!-- 电子签约 -->
    <el-dialog title="提交电子签约信息" :visible.sync="showEleInfo" width="1100px">
      <el-form :model="eleForm" :inline="true" :rules="eleRules" ref="eleForm" label-width="135px">
        <el-form-item label="签约模板" prop="tempid">
          <el-select v-model="TempName" placeholder="" clearable filterable size="small" style="width:200px" value-key="TempId" @change="changeTemp">
            <el-option v-for="(item, index) in tempList" :key="index" :label="item.TempName" :value="item.TempName" size="small"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型">
          <el-input v-model="tempType" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户合同主体" prop="StrCustName">
            <el-input v-model="StrCustName" readonly style="width:200px" disabled size="small"></el-input>
          </el-form-item> -->
        <el-form-item label="员工签约主体" prop="ContractSubject">
          <el-select v-model="eleForm.ContractSubject" placeholder="" clearable filterable style="width:200px" @change="changeLeg" size="small">
            <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人" prop="LegalPer">
          <el-input v-model="eleForm.LegalPer" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="RegisterAddress">
          <el-input v-model="eleForm.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="TaxNum" v-if="contractType < 8">
          <el-input v-model="eleForm.TaxNum" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="报税地" v-if="contractType < 8">
          <el-input v-model="eleForm.TaxCity" style="width:200px" size="small"></el-input>
        </el-form-item>
        <!-- <el-form-item label="客户单位全称">
            <el-input v-model="eleForm.ClientFullName" style="width:200px" size="small"></el-input>
          </el-form-item> -->

        <el-form-item label="合同/协议类型" prop="ProtocolType">
          <el-select v-model="eleForm.ProtocolType" value-key="name" placeholder="" clearable filterable size="small" @change="(val) => { changeCont(val, 'eleForm') }" style="width:200px">
            <el-option v-for="(item, index) in contractList" :key="index" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工作地点（区域）" prop="WorkSite" v-if="contractType == 5 || contractType == 6">
          <el-input v-model="eleForm.WorkSite" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="学校全称" prop="SchoolName" v-if="(contractType == 3 || contractType == 9) && no!=29">
          <el-input v-model="eleForm.SchoolName" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="学生专业" v-if="contractType == 9">
          <el-input v-model="eleForm.StudentMajor" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="入职日期" :prop="contractType == 8 || contractType == 9 || contractType == 10 ? '' : 'list[0].DtEntryBdate'" v-if="contractType != 11 && contractType != 12 && no!=24 && no!=26 && no!=27 && no!=28 && no!=29 && no!=32 && no!=33">
          <el-date-picker type="date" placeholder="" v-model="eleForm.list[0].DtEntryBdate" value-format="yyyy-MM-dd" style="width:200px" size="small" @blur="changeTimeLaborContract('eleForm', val)"></el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="文化程度" prop="StrEduLvl" v-if="contractType && contractType<=15">
              <el-input v-model="eleForm.StrEduLvl" style="width:200px" size="small"></el-input>
            </el-form-item>

            <el-form-item label="联系地址" prop="EmpContactAddress" v-if="contractType && contractType<=15">
              <el-input v-model="eleForm.EmpContactAddress" style="width:200px" size="small"></el-input>
            </el-form-item> -->

        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同起始时间' : '协议起始时间'" prop="ContractStartTime" v-if="contractType != 9 && contractType != 10 && contractType">
          <el-date-picker type="date" placeholder="" v-model="eleForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item v-if="contractType != 9 && contractType != 10 && contractType != 11 && contractType != 12 && contractType != 13 && contractType && no!=26 && no!=33">
          <template #label>
            <span v-if="contractType != 9 || contractType != 10">合同时长<span style="color:red">{{ no==30 || no==33 ? '（月）' : '（年）'}}</span></span>
            <span v-else>协议时长<span style="color:red">{{ no==30 ? '（月）' : '（年）'}}</span></span>
          </template>
          <el-input type="number" v-model="ContractTime" @blur="getContractEndDate(ContractTime,'eleForm')" style="width:200px" size="small" :disabled="!eleForm.ContractStartTime"></el-input>
        </el-form-item>
        <el-form-item v-if="no==33">
          <template #label>
            <span>合同时长（<span style="color:red">月</span>）</span>
          </template>
          <el-input type="number" v-model="eleForm.WorkingMonth" @blur="getContractEndDate(eleForm.WorkingMonth,'eleForm')" style="width:200px" size="small" :disabled="!eleForm.ContractStartTime"></el-input>
        </el-form-item>
        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同结束时间 （可编辑更改）' : '协议结束时间 （可编辑更改）'" prop="ContractEndTime" v-if="contractType != 9 && contractType != 10 && contractType">
          <el-date-picker type="date" placeholder="" v-model="eleForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="试用期起始时间" prop="TrialPeriodStartTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TrialPeriodStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="试用期时长(月)" prop="TrialMonth" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-input type="number" v-model="eleForm.TrialMonth" style="width:200px" size="small" :disabled="!eleForm.TrialPeriodStartTime" @blur="getEndDate('eleForm')"></el-input>
        </el-form-item>
        <el-form-item label="试用期结束时间（可编辑更改）" prop="TrialPeriodEndTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TrialPeriodEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>

        <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间' : '终止（解除）协议时间'" prop="TimeLaborContract" v-if="contractType == 8 || contractType == 9 || contractType == 10">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TimeLaborContract" value-format="yyyy-MM-dd" style="width:200px" size="small" @change="val => { changeTimeLaborContract('eleForm', val) }"></el-date-picker>
        </el-form-item>

        <el-form-item label="工作时长(年)" prop="WorkingYear" v-if="contractType == 8">
          <el-input v-model="eleForm.WorkingYear" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工作时长(月)" prop="WorkingMonth" v-if="contractType == 8">
          <el-input v-model="eleForm.WorkingMonth" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工作时长(天)" prop="WorkingDay" v-if="contractType == 8">
          <el-input v-model="eleForm.WorkingDay" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item :label="no != 30 ? '发薪日' : '发放日'" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no != 31">
          <el-input v-model="eleForm.PayDay" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="工资标准方式" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no != 30 && no != 31">
          <el-select v-model="eleForm.MeansOfPayments" placeholder="" clearable filterable size="small" style="width:200px">
            <el-option value="0" label="固定工资" size="small"></el-option>
            <el-option value="1" label="基本工资+绩效工资" size="small"></el-option>
            <el-option value="2" label="计件工资" size="small"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="城市" v-if="no == 23 || no == 2">
          <el-input v-model="eleForm.WorkCity" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工资" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13 && no!=25 && no!=26 && no!=30 && no!=31 && no!=33 && no!=33" :prop="no==24 || no==27 || no==28 || no==29 ? 'Yuan' : ''">
          <el-input v-model="eleForm.Yuan" type="number" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="月岗位工资" v-if="no == 33 || no == 34" prop="list[0].StrInterDurMonths">
          <el-input v-model="eleForm.list[0].StrInterDurMonths" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="月绩效工资" v-if="no == 33 || no == 34" prop="list[0].StrReasonLeaving">
          <el-input v-model="eleForm.list[0].StrReasonLeaving" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="税前基本工资" v-if="no==32">
          <el-input v-model="eleForm.list[0].StrWorkHours" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="税前月岗位津贴" v-if="no==32">
          <el-input v-model="eleForm.list[0].StrInterDurMonths" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="城市" v-if="no == 23 || no == 2">
          <el-input v-model="eleForm.WorkCity" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="工时" v-if="no == 23 || no == 24" :prop="no == '24' ? 'WorkTime' : ''">
          <el-select v-model="eleForm.WorkTime" placeholder="" clearable filterable size="small" style="width:200px">
            <el-option label="标准工时制" value="0"></el-option>
            <el-option label="不定时工时制" value="1"></el-option>
            <el-option label="综合计算工时制" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注1" v-if="contractType == 11">
          <el-input v-model="eleForm.list[0].Remark1" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="备注2" v-if="contractType == 11 && no != 25">
          <el-input v-model="eleForm.list[0].Remark2" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="备注3" v-if="contractType == 11 && no != 25">
          <el-input v-model="eleForm.list[0].Remark3" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间（员工联）' : '终止（解除）协议时间（员工联）'" prop="TimeLaborContractStaff" v-if="contractType == 8 || contractType == 9 || contractType == 10">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TimeLaborContractStaff" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>

        <el-table :data="eleForm.list" class="doc_table" border max-height="300px" style="width:100%;margin-top: 10px;">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PhoneNum" label="电话" :show-overflow-tooltip="true" align="center" min-width="95">
          </el-table-column>
          <el-table-column prop="StrIdCard" label="身份证号码" :show-overflow-tooltip="true" align="center" min-width="156">
          </el-table-column>
          <el-table-column prop="StrprojectName" label="项目名称" :show-overflow-tooltip="true" align="center" min-width="140">
            <template>{{ eleForm.ObjName }}</template>
          </el-table-column>
          <el-table-column prop="Gender" label="性别" v-if="no==32" align="center" min-width="120">
            <template slot-scope="{row}">
              <el-select v-model="row.Gender" placeholder="" clearable filterable style="width:100px" size="small">
                <el-option value="男"></el-option>
                <el-option value="女"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="JobName" label="合同岗位" align="center" min-width="140px">
            <template slot-scope="{row}">
              <el-input v-model="row.JobName" size="small" style="width:130px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="StrEduLvl" label="文化程度" :show-overflow-tooltip="true" align="center" min-width="130">
            <template slot-scope="{row}">
              <el-select v-model="row.StrEduLvl" size="small" style="width: 110px;" placeholder="" filterable>
                <el-option value="博士"></el-option>
                <el-option value="硕士"></el-option>
                <el-option value="本科"></el-option>
                <el-option value="大专"></el-option>
                <el-option value="中专"></el-option>
                <el-option value="高中"></el-option>
                <el-option value="初中及以下"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="ClientFullName" label="客户单位全称" align="center" min-width="140px">
            <template slot-scope="{row}">
              <el-input v-model="row.ClientFullName" size="small" style="width:130px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="Bankcard" label="银行卡号" align="center" min-width="130">
            <template slot-scope="{row}">
              <el-input v-model="row.Bankcard" size="small" style="width:120px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="DepositBank" label="开户银行" align="center" min-width="130">
            <template slot-scope="{row}">
              <el-input v-model="row.DepositBank" size="small" style="width:120px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="EmpContactAddress" label="户籍地址" align="center" min-width="200">
            <template slot-scope="{row}">
              <el-input v-model="row.EmpContactAddress" size="small" style="width:190px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="部门" align="center" min-width="200" v-if="no == 24">
            <template slot-scope="{row}">
              <el-input v-model="row.StrDep" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="试用期工资" align="center" min-width="200" v-if="no == 24">
            <template slot-scope="{row}">
              <el-input v-model="row.TrialPeriodDec" size="small" type="number" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="暂缓缴纳原因" align="center" min-width="200" v-if="no == 25">
            <template slot-scope="{row}">
              <el-input v-model="row.StrReasonzh" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="补贴金额" align="center" min-width="200" v-if="no && no!=26 && no!=28 && no!=29">
            <template slot-scope="{row}">
              <el-input v-model="row.SubsidyAmount" size="small" type="number" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="补贴金额大写" align="center" min-width="200" v-if="no && no!=26 && no!=28 && no!=29">
            <template slot-scope="{row}">
              <el-input v-model="row.SubsidyInstru" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="保密年限" align="center" min-width="200" v-if="no == 30">
            <template slot-scope="{row}">
              <el-input v-model="row.ConfiPeriod" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="个人电子邮箱" align="center" min-width="200" v-if="no == 27 || no==28 || no==29 || no==32 || no==35|| no==36">
            <template slot-scope="{row}">
              <el-input v-model="row.StrPsnEmail" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="个人微信号" align="center" min-width="200" v-if="no == 27 || no==28 || no==29">
            <template slot-scope="{row}">
              <el-input v-model="row.StrPsnWx" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="个人QQ" align="center" min-width="200" v-if="no == 27 || no==28 || no==29">
            <template slot-scope="{row}">
              <el-input v-model="row.StrPsnQq" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="紧急联系人" align="center" min-width="200" v-if="no == 27 || no == 33 || no==35|| no==36">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContact" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="紧急联系人电话" align="center" min-width="200" v-if="no == 27 || no == 33 || no==35|| no==36">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContactPhone" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="紧急联系人邮箱" align="center" min-width="200" v-if="no == 27">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContactEmail" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="紧急联系人地址" align="center" min-width="200" v-if="no == 27">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContactAddr" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="月岗位工资" align="center" min-width="200" v-if="no == 33">
            <template slot-scope="{row}">
              <el-input v-model="row.StrInterDurMonths" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="月绩效工资" align="center" min-width="200" v-if="no == 33">
            <template slot-scope="{row}">
              <el-input v-model="row.StrReasonLeaving" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="税前基本工资" align="center" min-width="200" v-if="no == 32">
            <template slot-scope="{row}">
              <el-input v-model="row.StrWorkHours" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="税前月岗位津贴" align="center" min-width="200" v-if="no == 32">
            <template slot-scope="{row}">
              <el-input v-model="row.StrInterDurMonths" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="合同结束标准" align="center" min-width="200" v-if="no == 35">
            <template slot-scope="{row}">
              <el-input v-model="row.StrPsnQq" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="验收标志" align="center" min-width="200" v-if="no == 35">
            <template slot-scope="{row}">
              <el-input v-model="row.StrEmContactAddr" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="律师费金额" align="center" min-width="200" v-if="contractType!=8 && contractType!=9 && contractType!=10 && contractType!=12 && contractType!=13">
            <template slot-scope="{row}">
              <el-input v-model="row.LegalFeesAmount" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="律师费金额大写" align="center" min-width="200" v-if="contractType!=8 && contractType!=9 && contractType!=10 && contractType!=12 && contractType!=13">
            <template slot-scope="{row}">
              <el-input v-model="row.LegalFeesAmountWords" size="small" style="width:140px"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEleInfo = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="confirmToEle()" style="margin-left:10px">
          <el-button type="primary" slot="reference" v-preventReClick size="small">去电子签约</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
    <el-dialog title="线下签约登记" :visible.sync="showOfflineSigning" width="800px">
      <el-form :model="offRegForm" :rules="offRegRules" ref="offRegForm" :inline="true" label-width="125px">
        <el-form-item label="身份证姓名" prop="Name">
          <el-input v-model="offRegForm.Name" size="small" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="StrIdCard">
          <el-input v-model="offRegForm.StrIdCard" size="small" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="项目名称" prop="StrObjName">
          <el-select v-model="offRegForm.StrObjName" placeholder="" clearable filterable size="small" style="width:200px">
            <el-option v-for="item in proNameList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="员工签约主体" prop="ContractSubject">
          <el-select v-model="offRegForm.ContractSubject" placeholder="" clearable filterable size="small" style="width:200px">
            <el-option v-for="(item, index) in legList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签约类型" prop="TempType">
          <el-select v-model="offRegForm.TempType" placeholder="" clearable filterable size="small" style="width:200px">
            <el-option value="用工协议"></el-option>
            <el-option value="证明文件"></el-option>
            <el-option value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入职日期" prop="dtEntryBDate">
          <el-date-picker type="date" placeholder="" v-model="offRegForm.dtEntryBDate" value-format="yyyy-MM-dd" size="small" style="width:200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同签约时间" prop="SignatureTime">
          <el-date-picker type="date" placeholder="" v-model="offRegForm.SignatureTime" value-format="yyyy-MM-dd" size="small" style="width:200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同起始时间" prop="ContractStartTime">
          <el-date-picker type="date" placeholder="" v-model="offRegForm.ContractStartTime" value-format="yyyy-MM-dd" size="small" style="width:200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间" prop="ContractEndTime">
          <el-date-picker type="date" placeholder="" v-model="offRegForm.ContractEndTime" value-format="yyyy-MM-dd" size="small" style="width:200px"></el-date-picker>
        </el-form-item>
        <el-form-item label="附件">
          <div class="upload_box">
            <el-upload class="upload-demo" action="" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList">
              <el-button size="small" type="success">上传附件</el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showOfflineSigning = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="confirmOfflineSigning" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="showWarnMsg" width="700px">
      <div v-html="warnMsg">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showWarnMsg = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="打印" :visible.sync="showPrint" width="920px">
      <!-- 打印 -->
      <Print ref="printRef" @closePrint="closePrint" :printList=printList></Print>
    </el-dialog>

    <!-- 导出 -->
    <el-dialog title="导出" :visible.sync="dialogVisible4" width="800px">
      <div>
        <el-form>
          <el-form-item label="导出项目" size="small">
            <el-select v-model="expObjname" placeholder="" size="small" style="width: 300px;" clearable filterable @change="changeExpObj">
              <el-option value="" label="全部"></el-option>
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="margin-bottom: 12px; margin-top: 15px; font-size: 16px">
          选择导出字段
        </div>
        <el-card class="box-card">
          <!-- <div slot="header" class="clearfix">
            <span>固定字段</span>
          </div> -->
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="margin-bottom: 5px;">全选</el-checkbox>
          <div class="fieldsBox">
            <div style="margin: 15px 0"></div>
            <el-checkbox-group v-model="checkedFields" @change="handleCheckedCitiesChange">
              <div class="fieldBox">
                <el-checkbox v-for="(field, index) in allFieldNameList" :label="field" :key="index">{{ field
                }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </el-card>
        <div style="margin-top: 20px">
          <div class="delTitle">选择导出人员在/离职状态</div>
          <div>
            <div class="dataSele">
              <el-select v-model="workState" slot="prepend" placeholder="请选择" filterable>
                <el-option label="全部" value=""></el-option>
                <el-option value="在职"></el-option>
                <el-option value="离职"></el-option>
                <el-option value="离职转正"></el-option>
                <el-option value="自离"></el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="dialogVisible4 = false">取消</button>
        <button class="search" @click="confirmExport()" style="margin-left: 10px; font-weight: 600">
          确定
        </button>
      </span>
    </el-dialog>

    <!-- 跟进弹框 -->
    <el-dialog title="跟进" :visible.sync="followVisible" width="800px" class="res_dialog">
      <el-tabs v-model="activeFollowName">
        <el-tab-pane label="人岗匹配推荐" name="人岗匹配推荐"></el-tab-pane>
        <el-tab-pane label="跟进记录" name="跟进记录"></el-tab-pane>
        <el-tab-pane label="流程记录" name="流程记录"></el-tab-pane>
      </el-tabs>
      <div class="f_list_box" v-if="activeFollowName == '人岗匹配推荐'">
        <el-table v-loading="recommendLoading" :data="recommendList" class="re_table" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{ (Number(matchQuery.pageNum) - 1) * Number(matchQuery.pageSize) + Number($index) + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="项目" min-width="90px">
            <template slot-scope="{row}">
              <span>{{ row.StrprojectName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="岗位" min-width="90px">
            <template slot-scope="{row}">
              <span>{{ row.CustomerJobName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="综合薪资" min-width="90px">
            <template slot-scope="{row}">
              <span v-if="!isNull(row.rpj.ComprehensiveSalary)">
                {{ row.rpj.ComprehensiveSalary }}
                <span v-if="!isNull(row.rpj.ComprehensiveSalaryEnd)">{{ '~ ' + row.rpj.ComprehensiveSalaryEnd }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="上班地点" min-width="180px">
            <template slot-scope="{row}">
              <span>{{ row.rpj.InterviewProvinceName + row.rpj.InterviewCityName + row.rpj.InterviewAraeName +
                row.rpj.InterviewAddress }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fit :show-overflow-tooltip="true" label="最新缺口" min-width="90px">
            <template slot-scope="{row}">
              <span>{{ row.StrgapNum }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="recommendCurrentChange" :current-page.sync="matchQuery.pageNum" :page-size="matchQuery.pageSize" @size-change="recommendSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,prev,pager,next,jumper" :total="matchCount"></el-pagination>
        </div>
      </div>
      <div class="f_list_box" v-if="activeFollowName == '跟进记录'">
        <el-form :rules="followRules" ref="followForm" :model="recommendQuery" class="re_follow_form" label-width="130px">
          <!-- <el-form-item label="更新求职意向:" prop="StrUserJobhunt">
            <el-radio-group v-model="recommendQuery.StrUserJobhunt">
              <el-radio label="有工作考虑新机会"></el-radio>
              <el-radio label="在找工作"></el-radio>
              <el-radio label="不找工作"></el-radio>
              <el-radio label="未知"></el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="跟进内容:" prop="StrRemark">
            <el-input v-model="recommendQuery.StrRemark" type="textarea" rows="3" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="f_btns" v-if="activeFollowName == '跟进记录'">
          <el-button @click="followVisible = false" size="small">关闭</el-button>
          <el-button type="primary" class="com_dialog_btn" @click="saveFollowHandle" size="small">保存</el-button>
        </div>
        <el-table v-loading="followLoading" :highlight-current-row="false" class="re_table" :data="followData" style="width:100%;max-height:200px;overflow-y:auto;">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{ (Number(followQuery.currpage) - 1) * Number(followQuery.perpage) + Number($index) + 1 }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="求职意愿" min-width="110px">
            <template slot-scope="{row}">
                <span>{{row.StrUserJobhunt}}</span>
              </template>
          </el-table-column> -->
          <el-table-column align="center" label="跟进内容" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.StrRemark }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="发言人" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.userName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="时间" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ isNull(row.DtInserDate) ? '' : row.DtInserDate.replace('T', ' ') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange1" :current-page.sync="followQuery.currpage" :page-size="followQuery.perpage" @size-change="handleSizeChange1" :page-sizes="[10, 20, 50, 100]" layout="total,prev,pager,next,jumper" :total="totalFollow"></el-pagination>
        </div>
      </div>
      <div class="f_list_box" v-if="activeFollowName == '流程记录'">
        <el-table v-loading="serviceLoading" :highlight-current-row="false" class="re_table" :data="serviceData" style="width:100%">
          <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
            <template slot-scope="{$index}">
              <span>{{ (Number(serviceQuery.currpage) - 1) * Number(serviceQuery.perpage) + Number($index) + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="项目名称" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.StrprojectName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="岗位名称" min-width="90px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.JobCategory }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流程名称" min-width="90px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.StrState }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流程时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span v-if="row.StrState == '已报名'">{{ isNull(row.DtInserDate) ? '' : row.DtInserDate.replace('T', ' ')
              }}</span>
              <span v-if="row.StrState == '约面'">{{ isNull(row.Dtappotime) ? '' : row.Dtappotime.replace('T', ' ')
              }}</span>
              <span v-if="row.StrState == '入职'">{{ isNull(row.DtInducttime) ? '' : row.DtInducttime.replace('T', ' ')
              }}</span>
              <span v-if="row.StrState == '离职'">{{ isNull(row.Dtquittime) ? '' : row.Dtquittime.replace('T', ' ')
              }}</span>
              <span v-if="row.StrState == '通过'">{{ isNull(row.Dtreachtime) ? row.Dtadopttime : row.Dtreachtime }}</span>
              <span v-if="row.StrState == '到面'">{{ isNull(row.Dtfacetime) ? '' : row.Dtfacetime.replace('T', ' ')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作人员" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.Username }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作时间" min-width="100px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ isNull(row.DtInserDate) ? '' : row.DtInserDate.replace('T', ' ') }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="流程备注" min-width="110px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{ row.StrRemark }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange2" :current-page.sync="serviceQuery.currpage" :page-size="serviceQuery.perpage" @size-change="handleSizeChange2" :page-sizes="[10, 20, 50, 100]" layout="total,prev,pager,next,jumper" :total="totalService"></el-pagination>
        </div>
      </div>
    </el-dialog>

    <!-- 标签弹框 -->
    <el-dialog title="标签" :visible.sync="labelVisible" width="600px" class="res_dialog">
      <div class="e_txt_box">
        <el-button type="text" @click="addLabelHandle">打标签</el-button>
      </div>
      <el-form ref="noticeForm" class="re_dialog_form" label-width="80px">
        <el-form-item label="" v-if="!isNull(lPubDialogList)">
          <span v-for="(item, index) in lPubDialogList" :key="index">{{ item.LableName + ';' }}</span>
        </el-form-item>
        <!-- <el-form-item label="私有标签:" v-if="!isNull(lPriDialogList)">
          <span v-for="(item,index) in lPriDialogList" :key="index">{{item.LableName+';'}}</span>
        </el-form-item>
        <el-form-item label="私有标签:" v-if="isNull(lPriDialogList)">
          <span>暂无数据</span>
        </el-form-item> -->
      </el-form>
      <div class="com_empty" v-if="isNull(lPubDialogList)">
        <p>暂无数据</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="com_dialog_btn" @click="labelVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 添加标签弹框 -->
    <el-dialog title="编辑标签" :visible.sync="addlabelVisible" width="700px" class="res_dialog">
      <div class="r_label_box" v-loading="laloading">
        <el-tabs v-model="labelActiveName">
          <el-tab-pane label="全局标签" name="全局标签">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="item in publicList" :key="item.LbGroup.Id">
                <div class="dia_groupname">{{ item.LbGroup.LableName + '：' }}</div>
                <el-checkbox-group v-model="wholeCheckList" @change="dPubEnterHandle">
                  <el-checkbox v-for="(lab, index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                    <span v-if="lab.IsEnable">{{ lab.LableName }}</span>
                  </el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="私有标签" name="私有标签">
            <div class="dia_label_box">
              <div class="dia_label_item" v-for="item in privateList" :key="item.LbGroup.Id">
                <div class="dia_groupname">{{item.LbGroup.LableName + '：'}}</div>
                <div>
                  <el-checkbox-group v-model="wholeCheckList2" @change="dPraEnterHandle">
                    <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                      <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addlabelVisible = false" size="small">取消</el-button>
        <el-button type="primary" class="com_dialog_btn" @click="saveLabelHandle" size="small">保存</el-button>
      </span>
    </el-dialog>
    <!-- 导入弹框 -->
    <el-dialog :title="importName" :visible.sync="importVisible" width="700px" class="com_import_box">
      <el-steps :active="importActive" finish-status="success" class="steps-box">
        <el-step title="基础信息"></el-step>
        <el-step title="上传导入文件"></el-step>
        <el-step title="导入处理"></el-step>
      </el-steps>
      <div v-if="importActive == 0" style="margin-top:15px;padding-bottom:15px;">
        <div class="import_basic_box">
          <div>
            <div>导入表格:</div>
            <div class="storageArea">
              <div class="storageInput" style="margin:0 20px 0 0">
                <el-select v-model="importSignQuery.tabName" size="small" disabled placeholder="请选择导入表" filterable>
                  <el-option v-for="(item, index) in importTableList" :key="index" :label="item.StrTableName" :value="item.StrTableName"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="margin-left:100px">
            <div>导入模板下载:</div>
            <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;">下载模板</el-button>
          </div>
          <div>
            <div>项目:</div>
            <div class="storageArea">
              <div class="storageInput" style="margin:0 20px 0 0">
                <el-select v-model="importSignQuery.projectid" filterable clearable size="small" placeholder="" @change="impProChange">
                  <el-option v-for="(item, index) in searchProList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div style="margin-left:100px">
            <div>岗位:</div>
            <div class="storageArea">
              <div class="storageInput" style="margin:0 20px 0 0">
                <el-select v-model="importSignQuery.jobid" filterable clearable size="small" placeholder="" @change="impPostChange">
                  <el-option v-for="(item, index) in impJobList" :key="index" :label="item.CustomerJobName" :value="item.Id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="note-txt">
            <p style="font-weight:bold;">备注：</p>
            <p>1、批量导入待面试，项目和岗位必选。</p>
            <p>2、批量导入入离职，项目必选，岗位非必选。</p>
            <p>3、批量导入离职，人员名单仅限于花名册在职人员。</p>
          </div>
        </div>
      </div>
      <div v-if="importActive == 1" style="margin-top:15px;padding-bottom:15px;">
        <div class="note-txt">
          <p style="font-weight:bold;">上传文件说明：</p>
          <p>1. 支持文件后缀 xls、xlsx文件。</p>
          <p>2. 请将要上传的内容放在第一个sheet中。</p>
          <p>3. 请不要加密模板文件，将导致错误。</p>
          <p>4. 请不要上传带宏的文件，将导致错误。</p>
          <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。</p>
          <p>6. 导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。</p>
        </div>
        <div style="margin-top:10px">请选择导入文件（xls/xlsx格式）:</div>
        <div class="form-item" style="justify-content: space-between;">
          <div class="file-box">
            <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
            <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
            <label for="fileInput" class="file-btn">上传</label>
          </div>
        </div>
        <!-- 提示 -->
        <p style="color:red;" v-if="isError">{{ errorTxt }}</p>
        <div class="reimpArea">
          <div style="margin-top:10px">
          </div>
        </div>
      </div>
      <div v-if="importActive == 2" style="margin-top:15px;padding-bottom:15px;">
        <div class="result-box">
          <p><i class="el-icon-success" style="color: #409EFF;margin-right:5px"></i>导入数据正在处理中，导入结果请在’导入记录‘中查看。</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="importVisible = false" v-if="importActive == 0">取消</el-button>
        <el-button size="small" @click="prevSteps" v-if="importActive > 0 && importActive <= 1">上一步</el-button>
        <el-button type="primary" size="small" @click="nextSteps" v-if="importActive < 1">下一步</el-button>
        <el-tooltip effect="dark" content="未上传文件不能提交" :disabled="!isUploadSuccess" placement="top">
          <div style="display:inline-block;margin-left:10px">
            <el-button type="success" size="small" @click="lastSteps" element-loading-text="此操作可能耗费较长时间，请等待..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.fullscreen.lock="fullscreenLoading" v-if="importActive == 1" :disabled="isUploadSuccess">提交</el-button>
          </div>
        </el-tooltip>
        <el-button type="primary" size="small" @click="backHandle" v-if="importActive == 2">确认并返回</el-button>
        <el-button size="small" @click="resultHandle" v-if="importActive == 2">查看导入结果</el-button>
      </span>
    </el-dialog>


    <el-dialog title="批量商保增员" :visible.sync="showDeclare" width="1100px">
      <el-form :model="declareForm" :inline="true" :rules="declareRules" ref="declareForm" label-width="135px">
        <el-form-item label="险种名称">
          <el-select v-model="declareForm.Insurance.InsuranceId" placeholder="" size="small" @change="insChange" clearable filterable style="width:300px">
            <el-option v-for="(item, index) in planList" :key="index" :label="item.Bntype" :value="item.Id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可参保保单" prop="policy">
          <el-select v-model="policy" placeholder="" value-key="Id" size="small" clearable filterable style="width:300px" @change="policyChange">
            <el-option v-for="(item, index) in policyList" :key="index" :label="item.CoverStartTime.split('T')[0] + ' ~ ' + item.CoverEndTime.split('T')[0]" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="保障期限" prop="Insurance.InsuranceStartTime">
          <div class=" flex aic">
            <el-date-picker type="date" placeholder="" v-model="declareForm.Insurance.InsuranceStartTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
            <div style="margin: 0 5px;">-</div>
            <el-date-picker type="date" placeholder="" v-model="declareForm.Insurance.InsuranceEndTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="项目名称" prop="Insurance.Projectid">
          <el-input v-model="declareForm.Insurance.ProjectName" style="width:300px" size="small" readonly disabled></el-input>
        </el-form-item>

        <el-form-item label="批量岗位">
          <el-input v-model="batchJobName" style="width:300px" size="small" @blur="batchChangeJobName(batchJobName)"></el-input>
        </el-form-item>
        <el-form-item label="批量职业类别">
          <el-select v-model="batchJobClasss" placeholder="" clearable size="small" style="width:300px" @change="batchChangeJobClasss">
            <el-option v-for="(item, index) in JobClasssList" :key="index" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批量员工属性">
          <el-select v-model="batchEmployeeAttribute" placeholder="" clearable size="small" style="width:300px" @change="batchChangeEmployeeAttribute">
            <el-option value="长期工"></el-option>
            <el-option value="临时工"></el-option>
            <el-option value="日结工"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批量劳动合同公司">
          <el-select v-model="batchLaborContractUnit" placeholder="" clearable size="small" style="width:300px" filterable @change="batchChangeLaborContractUnit">
            <el-option v-for="(item, index) in legList2" :key="index" :value="item.companyName"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-table :data="declareForm.userList" class="ele_table" max-height="300px" style="width:100%;">+
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="MainlinsuredName" label="被保险人姓名" :show-overflow-tooltip="true" align="center" width="100">
        </el-table-column>
        <el-table-column prop="MainlinsuredCardId" label="被保险人证件" :show-overflow-tooltip="true" align="center" width="155">
        </el-table-column>
        <el-table-column prop="MainlinsuredPhone" label="被保险人手机号" :show-overflow-tooltip="true" align="center" width="120">
        </el-table-column>
        <el-table-column prop="JobName" label="岗位" align="center">
          <template slot="header">
            <span>
              岗位
              <el-tooltip :content="JobNameTip" placement="top" effect="light">
                <i class="el-icon-question cp"></i>
              </el-tooltip>
            </span>
          </template>
          <template slot-scope={row}>
            <el-input v-model="row.JobName" style="width:120px" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="JobClasss" label="职业类别" :show-overflow-tooltip="true" align="center">
          <template slot="header">
            <span>
              职业类别
              <el-tooltip :content="JobClasssTip" placement="top" effect="light">
                <i class="el-icon-question cp"></i>
              </el-tooltip>
            </span>
          </template>
          <template slot-scope={row}>
            <el-select v-model="row.JobClasss" placeholder="" clearable size="small" style="width:120px">
              <el-option v-for="(item, index) in JobClasssList" :key="index" :value="item"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="EmployeeAttribute" label="员工属性" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>
            <el-select v-model="row.EmployeeAttribute" placeholder="" clearable size="small" style="width:120px">
              <el-option value="长期工"></el-option>
              <el-option value="临时工"></el-option>
              <el-option value="日结工"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="LaborContractUnit" label="劳动合同公司" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>
            <el-select v-model="row.LaborContractUnit" placeholder="" clearable size="small" style="width:120px" filterable>
              <el-option v-for="(item, index) in legList2" :key="index" :value="item.companyName"></el-option>
            </el-select>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDeclare = false" size="small">取消</el-button>
        <el-popconfirm title="请确认是否继续？" @confirm="confirmToInsure()" style="margin-left:10px">
          <el-button type="primary" slot="reference" v-preventReClick size="small">提 交</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="showResubmit" width="450px">
      <div>{{ submitMsg }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelSubmit" size="small">取消</el-button>
        <el-button type="danger" v-preventReClick size="small" @click="forceSubmit">强制提交</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import moment from 'moment';
  import FUN from "./../../fun";
  import xz from "../../common";
  import Print from "./components/Print.vue"
  import ResourceComTabs from "./components/resourceComTabs.vue"
  import "moment-precise-range-plugin"
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    i
  } from 'mathjs';
  export default {
    components: {
      ResourceComTabs,
      Print
    },
    data() {
      var validatetInsuranceTime = (rule, value, callback) => {
        if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障开始时间"));
        } else if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障结束时间"));
        } else {
          callback();
        }
      };
      return {
        showDropScreen: -1,
        activeName: '在职',
        tableHeight: 0,
        ageStart: null,
        ageEnd: null,
        listQuery: {
          userid: Cookies.get("userid-b"),
          type: 1, //查询类型1：在职2：离职0：全量
          strEmpName: '',
          strIdCard: '',
          strPhoneNum: '',
          dtInsertDate: '',
          projectid: 0, //项目0:全部
          strOther: '-1', //临时工-1：全部1：是0：否
          ageStart: '-1', //年龄始-1:全部
          ageEnd: '-1', //年龄止-1：全部
          expiration: '0', //到期提醒 0:全部 1:身份证到期 2:试用期到期 3:合同到期 4:16周岁以下 5:16~18周岁 6:退休男 7:退休女 8:65周岁以上 9:工伤纠纷
          strEduLv: [],
          dtEntryBdateStart: '', //用工之日始
          dtEntryBdateEnd: '', //用工之日止
          strContractType: [], //合同（协议）类型
          pushName: [],
          pushRemark: '',
          isEnrollment: '-1', //是否参保-1：全部1：是0：否
          isSigning: '-1', //是否签约-1：全部1：是0：否2:将到期
          dtDepartureDateStart: '',
          dtDepartureDateEnd: '',
          pagination: {
            page: 1,
            pageSize: 10,
            orders: []
          }
        },
        butQuery: {
          path: '/signupList',
          powerEnName: 'employee'
        },
        totalCount: 0,
        permissionLists: [], //按钮权限列表
        roletype: localStorage.loginRoletype,
        showDropScreen: -1,
        proNameList: [], //服务商方案列表
        customerList: [],
        loading: false,
        tableData: [],
        // 表头参数
        titleQuery: {
          strTableId: 'JB_emp_UserBase',
          strIsFixed: '' // 1 基础 0 扩展 空 所有
        },
        multipleSelection: [],
        quitList: [],
        printList: [],
        showQuitSign: false,
        isBtnLoading: false,
        showEleInfo: false,
        tempType: '',
        StrCustName: '',
        jobNameLabel: '',
        TempName: '', //签约模板
        eleForm: { //电子签约信息表单
          tempid: '', //模板id
          ObjName: '',
          ContractSubject: '', //员工签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          TaxNum: '',
          TaxCity: '',
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期开始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试用期时长
          ProtocolType: '', //合同/协议类型
          JobName: '', //岗位
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          Bankcard: '', //银行卡号
          DepositBank: '', //开户银行
          WorkingYear: '', //工作时长(年)
          WorkingMonth: '', //工作时长(月)
          WorkingDay: '', //工作时长(天)
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
          StrEduLvl: '', //文化程度
          EmpContactAddress: '', //联系地址
          MeansOfPayments: '', //工资标准方式
          PayDay: '',
          Yuan: '',
          WorkCity: '',
          WorkTime: '',
          list: [{
            name: '',
            PhoneNum: '',
            StrIdCard: '',
            DtEntryBdate: '', //入职日期
            JobName: '', //岗位
            StrEduLvl: '', //文化程度
            ClientFullName: '',
            EmpContactAddress: '', //联系地址
            Bankcard: '', //银行卡号
            DepositBank: '', //开户银行
            Remark1: '',
            Remark2: '',
            Remark3: '',
            ConfiPeriod: ''
          }], //选中的在职人员列表
        },
        tempList: [], //签约模板
        contractList: this.$store.state.EMP.contractList, //合同/协议列表
        contractType: null, //选择的合同类型
        no: '', //选择的合同no
        legList: [],
        ContractTime: null,
        eleRules: {
          tempid: {
            required: true,
            message: '请选择模板',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择员工签约主体',
            trigger: 'change'
          },
          LegalPer: {
            required: true,
            message: '请选择法人',
            trigger: 'change'
          },
          RegisterAddress: {
            required: true,
            message: '请选择注册地址',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
          TrialPeriodStartTime: {
            required: true,
            message: '请选择试用期起始时间',
            trigger: 'change'
          },
          TrialPeriodEndTime: {
            required: true,
            message: '请选择试用期结束时间',
            trigger: 'change'
          },
          TrialMonth: {
            required: true,
            message: '请输入试用期时长',
            trigger: 'blur'
          },
          ProtocolType: {
            required: true,
            message: '请选择合同/协议类型',
            trigger: 'change'
          },
          JobName: {
            required: true,
            message: '请输入工作岗位（工种）',
            trigger: 'blur'
          },
          SchoolName: {
            required: true,
            message: '学校全称',
            trigger: 'blur'
          },
          WorkSite: {
            required: true,
            message: '请输入工作地点（区域）',
            trigger: 'blur'
          },
          WorkingYear: {
            required: true,
            message: '请输入工作时长(年)',
            trigger: 'blur'
          },
          WorkingMonth: {
            required: true,
            message: '请输入工作时长(月)',
            trigger: 'blur'
          },
          WorkingDay: {
            required: true,
            message: '请输入工作时长(天)',
            trigger: 'blur'
          },
          TimeLaborContract: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间',
            trigger: 'change'
          },
          TimeLaborContractStaff: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间（员工联）',
            trigger: 'change'
          },
          StudentMajor: {
            required: true,
            message: '请输入学生专业',
            trigger: 'blur'
          },
          PayDay: {
            required: true,
            message: '请输入发薪日',
            trigger: 'blur'
          },
          MeansOfPayments: {
            required: true,
            message: '请选择工资标准方式',
            trigger: 'blur'
          },
          Yuan: {
            required: true,
            message: '请输入工资',
            trigger: 'blur'
          },
          StrReasonzh: {
            required: true,
            message: '请输入暂缓缴纳原因',
            trigger: 'blur'
          },
          WorkTime: {
            required: true,
            message: '请输入工时',
            trigger: 'blur'
          },
          WorkingYear: {
            required: true,
            message: '请输入工作时长(年)',
            trigger: 'blur'
          },
          WorkingMonth: {
            required: true,
            message: '请输入工作时长(月)',
            trigger: 'blur'
          },
          WorkingDay: {
            required: true,
            message: '请输入工作时长(天)',
            trigger: 'blur'
          },
          TimeLaborContract: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间',
            trigger: 'change'
          },
          TimeLaborContractStaff: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间（员工联）',
            trigger: 'change'
          },
          StudentMajor: {
            required: true,
            message: '请输入学生专业',
            trigger: 'blur'
          },
          'list[0].StrEduLvl': {
            required: true,
            message: '请输入文化程度',
            trigger: 'blur'
          },
          'list[0].EmpContactAddress': {
            required: true,
            message: '请输入联系地址',
            trigger: 'blur'
          },
          'list[0].TrialPeriodDec': {
            required: true,
            message: '请输入试用期工资',
            trigger: 'blur'
          },
          'list[0].StrDep': {
            required: true,
            message: '请输入部门',
            trigger: 'blur'
          },
          'list[0].StrReasonLeaving': {
            required: true,
            message: '请输入离职原因',
            trigger: 'blur'
          },
          'list[0].Bankcard': {
            required: true,
            message: '请输入银行卡号',
            trigger: 'blur'
          },
          'list[0].DepositBank': {
            required: true,
            message: '请输入开户银行',
            trigger: 'blur'
          },
          'list[0].StrRegAddress': {
            required: true,
            message: '请输入户籍地址',
            trigger: 'blur'
          },
          'list[0].StrRegType': {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
          'list[0].StrRegType': {
            required: true,
            message: '请输入户籍类型',
            trigger: 'blur'
          },
          'list[0].StrPsnWx': {
            required: true,
            message: '请输入个人微信号',
            trigger: 'blur'
          },
          'list[0].StrEmContact': {
            required: true,
            message: '请输入紧急联系人',
            trigger: 'blur'
          },
          'list[0].StrEmContactPhone': {
            required: true,
            message: '请输入紧急联系人电话',
            trigger: 'blur'
          },
          'list[0].StrEmContactAddr': {
            required: true,
            message: '请输入紧急联系人地址',
            trigger: 'blur'
          },
          'list[0].StrWorkHours': {
            required: true,
            message: '请输入工作小时',
            trigger: 'blur'
          },
          'list[0].StrWorkDays': {
            required: true,
            message: '请输入工作天数',
            trigger: 'blur'
          },
          'list[0].StrInterDurMonths': {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
        },
        offRegForm: { //线下签约登记表单
          Id: '',
          Name: '',
          PhoneNum: '',
          StrObjName: '', //项目名称
          StrIdCard: '', //身份证
          TempType: '', //签约类型
          StrObjName: '', //项目名称
          ContractSubject: '', //员工签约主体
          SignatureTime: '', //合同签约时间
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          dtEntryBDate: '', //入职日期
          AttachUrl: '', //合同附件
        },
        fileList: [],
        showOfflineSigning: false,
        offRegRules: {
          Name: {
            required: true,
            message: '请输入姓名',
            trigger: 'change'
          },
          StrIdCard: {
            required: true,
            message: '请输入身份证号码',
            trigger: 'change'
          },
          StrObjName: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          dtEntryBDate: {
            required: true,
            message: '请选择入职日期',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择员工签约主体',
            trigger: 'change'
          },
          TempType: {
            required: true,
            message: '请选择员工签约类型',
            trigger: 'change'
          },
          SignatureTime: {
            required: true,
            message: '请选择合同签约时间',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
        },
        dtDepartureDate: '', //离职时间
        dtRealDepartureDate: '', //实际离职时间
        strWorkState: '',
        isBlack: '',
        showWarnMsg: false,
        warnMsg: '',
        showPrint: false,
        info: {},
        rowInfo: {},
        checked: false,
        checked2: false,
        checkList: [],
        dialogVisible4: false,
        isIndeterminate: true,
        isExping: false,
        isExping2: false,
        checkAll: false,
        checkedFields: [],
        fixedfields: [], //固定字段列表
        expandFieldList: [], //拓展字段列表
        allFieldList: [], //所有字段列表
        allFieldNameList: [], //所有字段名称的列表
        tableclumn: [],
        tableclumn1: [],
        tableclumn2: [],
        workState: '在职',
        // 跟进记录
        followQuery: {
          resumeId: '', //简历id
          currpage: 1,
          perpage: 10
        },
        matchQuery: {
          StrPlanstatus: '招聘中', // 招聘中或停招
          JobCategory: '',
          ResumeId: '',
          pageNum: 1,
          pageSize: 10
        },
        // 服务记录
        serviceQuery: {
          resumeId: '', //简历id
          roletype: localStorage.loginRoletype,
          currpage: 1,
          perpage: 10
        },
        recommendQuery: {},
        recommendLoading: false,
        followLoading: false,
        recommendList: [],
        matchCount: 0,
        followData: [],
        totalFollow: 0,
        serviceLoading: false,
        serviceData: [],
        totalService: 0,
        followVisible: false,
        labelActiveName: '全局标签',
        activeFollowName: '人岗匹配推荐',
        // 人岗匹配推荐
        followRules: {
          StrRemark: [{
            required: true,
            message: '请输入补充信息',
            trigger: 'blur'
          }]
        },
        resumeIds: '',
        labelVisible: false,
        includePublicChecks: [],
        includePrivateChecks: [],
        lPubDialogList: [],
        lPriDialogList: [],
        enTagChecks: [],
        // 标签列表
        wholeCheckList: [],
        wholeCheckList2: [],
        // 弹框选中的全局标签
        dCheckCommonLabelList: [],
        // 弹框选中的私有标签
        dCheckPriLabelList: [],
        // 添加标签弹框选中的标签
        diaTagChecks: [],
        addlabelVisible: false,
        // 全局标签列表
        publicList: [],
        importVisible: false,
        importSignQuery: {
          fileid: '花名册信息维护模板',
          tableid: 'JB_emp_PsnStatusDms', //JB_emp_PsnStatus 批量到面导入表 JB_emp_UserBase  批量导入入职模板（全量）
          tabName: '花名册信息维护模板',
          projectid: '',
          strprojectName: '', //选择的项目名称
          jobid: '', //选择的岗位
          customerJobName: '' //岗位名称
        },
        errorTxt: '',
        isUploadSuccess: false,
        fullscreenLoading: false,
        laloading: false,
        excelpath: '',
        // 导入参数
        ExcelSrc: {
          value: '',
          check: false,
          fileName: ''
        },
        importPostList: [],
        importName: '',
        isJobDownload: false, //是否下载过入职模板
        isJobDownloadzz: false, //是否下载过入职简易模板
        isDepartDownload: false, //是否下载过离职模板
        downSignQuery: { //下载模板
          tableid: ''
        },
        // 导入显示页面
        importActive: 0,
        // 导入岗位列表
        impJobList: [],
        importTableList: [{
            StrTableName: '花名册信息维护模板'
          },
          {
            StrTableName: '批量导入入职模板（全量）'
          },
          {
            StrTableName: '批量导入离职模板'
          }
        ],
        searchProList: [],
        // 导入查询参数
        stateInfoQuery: {
          pagecount: 10,
          currpage: 1,
          strOperType: '入职批量导入', //待面试批量导入 待入职批量导入 入职批量导入  离职批量导入
          excelname: '',
          tableid: "JB_emp_UserBase",
          datestart: '',
          dateend: '',
          strobjname: '',
          impdate: '',
          druserId: ''
        },
        tablePath: this.$store.state.EMP.tablePath,
        //表头错误提示
        isError: false,
        ObjName: '',
        expObjname: '', //导出项目名称
        activeName2: '0',
        insureList: [],
        showReduction: false,
        declareForm: {
          Insurance: {
            BusinessType: 1, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          userList: []
        },
        planList: [], //险种列表
        showDeclare: false,
        policy: '',
        policyList: [],
        declareRules: {
          'Insurance.InsuranceStartTime': {
            required: true,
            validator: validatetInsuranceTime,
            trigger: "change",
          },
          'Insurance.InsuranceId': {
            required: true,
            message: "请选择险种",
            trigger: "change",
          },
        },
        JobClasssList: ['1-4类', '5'],
        JobNameTip: '需要具体细化，参考《职业分类表》进行填写',
        JobClasssTip: '参考《职业分类表》',
        legList2: [],
        showResubmit: false,
        submitMsg: '', //重复提交提示
        batchJobName: '',
        batchJobClasss: '',
        batchEmployeeAttribute: '',
        batchLaborContractUnit: '',
        // 黑名单标签
        blackLabelList: [],
        ChannelsList: [{
            name: '无',
            value: 0
          },
          {
            name: '58',
            value: 1
          }, {
            name: '抖音',
            value: 2
          }, {
            name: '微信群或朋友圈',
            value: 3
          }, {
            name: '快手',
            value: 4
          }, {
            name: '小红书',
            value: 5
          }, {
            name: '其他网上招聘途径等',
            value: 6
          }, {
            name: '贴单',
            value: 7
          }, {
            name: '内荐（含熟人介绍）',
            value: 8
          }, {
            name: '设摊（含主动上门）',
            value: 9
          }, {
            name: '供应商',
            value: 10
          }, {
            name: '企业转移',
            value: 11
          }
        ],
        listQuerys: {
          projectid: 0,
          strUserName: '', // 姓名
          strMobile: '', // 联系方式
        }
      }
    },
    created() {
      this.tableHeight = Number(document.body.clientHeight)
      console.log(this.$route.query)
      this.getButtonPower();
      // this.getCustomList();
      this.getMemberList();
      this.getProList();
      this.getSearchProList();
      // 所有标签
      this.GetLabelManagement()
      this.getLegalSubjectList();
      this.getlegalsubjectlist2();
      this.getdictdatalistbyid('132')
    },
    computed: {
      filteredTableTitles() {
        if (this.activeName === '在职') {
          // 过滤掉在/离职状态、离职日期、实际离职日期字段
          return this.$store.state.EMP.tableTitle.filter(item =>
            !['strWorkState', 'dtDepartureDate', 'dtRealDepartureDate'].includes(item.StrColumId)
          );
        }
        return this.$store.state.EMP.tableTitle;
      }
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this;
        xz.getbtnPowerIdBypage(this.butQuery).then((res) => {
          // console.log('按钮',res)
          if (res.status == "ok") {
            let resmsg = res.msg;
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = [];
            }
          } else {
            this.permissionLists = [];
          }
        });
      },
      //获取法务主体列表
      getlegalsubjectlist2() {
        let str = `?pageNum=${1}&pageSize=${10000}`
        xz.ArdCurStatGetFun('GetLegalSubjectsList', str).then(res => {
          if (res.status == 'ok') {
            const excludedCompanies = [
              "无锡杰博人力资源有限公司",
              "杰博人力资源(西安)有限公司",
              "上海才服企业管理咨询有限公司",
              "杰博(重庆)人力资源服务有限公司",
              "南通市杰博人力资源有限公司"
            ];
            // 过滤掉 companyName 在 excludedCompanies 中的数据
            this.legList2 = res.data.date.filter(item => !excludedCompanies.includes(item.companyName));
          } else {
            this.legList2 = [];
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
            if (this.$route.query.active != undefined && this.$route.query.active) {
              this.activeName = this.$route.query.active;
            }
            if (this.$route.query.projectid != undefined && this.$route.query.projectid) {
              // let item = this.proNameList.find(e => e.StrprojectName == this.$route.query.objName)
              this.listQuery.projectid = Number(this.$route.query.projectid);
              this.listQuerys.projectid = Number(this.$route.query.projectid);
            }
            if (this.$route.query.strUserName != undefined && this.$route.query.strUserName) {
              this.listQuery.strEmpName = this.$route.query.strUserName;
              this.listQuerys.strUserName = this.$route.query.strUserName;
            }
            if (this.$route.query.strMobile != undefined && this.$route.query.strMobile) {
              this.listQuery.strPhoneNum = this.$route.query.strUserName;
              this.listQuerys.strMobile = this.$route.query.strMobile;
            }
            this.getList();
          } else {
            this.proNameList = [];
          }
        });
      },
      // 获取人员列表
      getMemberList() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      // 子组件传值
      async currChange(value) {
        // console.log('currChange', value)
        this.activeName = value
        // this.getCustomerList(this.infoQuery);
        this.listQuery.pagination.page = 1;
        if (this.$route.query.projectid != undefined && this.$route.query.projectid) {
        } else {
          this.getList();
        }
      },
      currentChange(val) {
        this.listQuery.pagination.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pagination.page = 1;
        this.listQuery.pagination.pageSize = val;
        this.getList();
      },
      getList() {
        if (this.activeName == '在职') {
          this.listQuery.type = 1
        } else if (this.activeName == '离职') {
          this.listQuery.type = 2
        } else {
          this.listQuery.type = 0
        }
        if (this.ageStart && this.ageEnd) {
          this.listQuery.ageStart = Number(this.ageStart);
          this.listQuery.ageEnd = Number(this.ageEnd);
        } else {
          this.listQuery.ageStart = '-1';
          this.listQuery.ageEnd = '-1';
        }
        if (!this.listQuery.projectid || this.listQuery.projectid == null) {
          this.listQuery.projectid = 0;
        }
        if (this.listQuery.dtEntryBdateStart == null) {
          this.listQuery.dtEntryBdateStart = ''
        }
        if (this.listQuery.dtEntryBdateEnd == null) {
          this.listQuery.dtEntryBdateEnd = ''
        }
        this.loading = true;
        xz.rcFun(this.listQuery, 'InterviewOnboarding/GetEmployeeList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data
            this.totalCount = res.data.totalCount
          } else {
            this.tableData = []
            this.totalCount = 0
          }
          this.loading = false;
        })
        this.listQuerys = {
          projectid: this.listQuery.projectid,
          strUserName: this.listQuery.strEmpName, // 姓名
          strMobile: this.listQuery.strPhoneNum, // 联系方式
          strIdCard: this.listQuery.strIdCard,
        }
        setTimeout(() => {
          this.$refs.child.getSignNum();
        }, 100);
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      editHandle(row) {
        const routerUrl = this.$router.resolve({
          path: "/rosterEmpEdit",
          query: {
            type: 'edit',
            strExcelPath: row.strExcelPath,
            intExcelLine: row.intExcelLine
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 离职弹框
      quitHandle(row) {
        // if(this.isNull(this.multipleSelection)){
        //   this.$message({ type: 'warning', message: '请选择面试未通过的数据' })
        //   return false;
        // }else{
        this.multipleSelection = [row];
        this.dtDepartureDate = '';
        this.strWorkState = '';
        this.insureList = [];
        this.quitList = [{
          strExcelPath: row.strExcelPath,
          intExcelLine: row.intExcelLine,
          gdststusID: '',
          strWorkState: '',
          strBlacklistReason: '',
          strRemark: '',
          dtDepartureDate: '',
          dtRealDepartureDate: '',
        }]
        if (row.isInsured == '是') {
          this.insureList = [row]
        }
        this.isBtnLoading = false;
        this.showQuitSign = true
        // }
      },
      //离职登记
      quitSign() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员');
        } else {
          this.dtDepartureDate = '';
          this.strWorkState = '';
          this.isBlack = '';
          this.quitList = [];
          this.insureList = [];
          this.multipleSelection.forEach(e => {
            let data = {
              strExcelPath: e.strExcelPath,
              intExcelLine: e.intExcelLine,
              gdststusID: '',
              strWorkState: '',
              strBlacklistReason: '',
              strRemark: '',
              dtDepartureDate: '',
              dtRealDepartureDate: '',
            }
            if (e.isInsured == '是') {
              this.insureList.push(e)
            }
            this.quitList.push(data)
          });
          this.isBtnLoading = false;
          this.showQuitSign = true;
        }
      },
      confirmQuit() {
        let canQuit = true;
        this.quitList.forEach((e, index) => {
          if (!e.strWorkState || !e.dtDepartureDate || !e.dtRealDepartureDate) {
            // this.$message.warning('第'+ (index+1) + '行 离职时间、离职类型 未完善')
            canQuit = false
          }
          if (index == this.quitList.length - 1) {
            if (canQuit) {
              this.isBtnLoading = true;
              let d = {
                type: 2, //类型1：待离职2：在职
                founder: Cookies.get("userid-b"),
                list: this.quitList
              }
              xz.rcFun(d, 'InterviewOnboarding/SetResignation').then(res => {
                if (res.status == 'ok') {
                  this.$message.success('离职操作成功！');
                  this.isBtnLoading = false;
                  this.showQuitSign = false;
                  this.getList();
                  if (this.insureList.length > 0) {
                    this.isBtnLoading = false;
                    this.showReduction = true;
                  }
                } else {
                  this.$message.error(res.msg);
                  this.isBtnLoading = false;
                }
              })
            } else {
              this.$message.warning('请完善离职信息')
            }
          }
        });
      },
      enterSignHandle() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          //判断是否选择了不同项目的人员
          this.ObjName = this.multipleSelection[0].strObjName;
          let hasDifferent = this.multipleSelection.some(val => val.strObjName != this.ObjName)
          console.log(hasDifferent)
          if (hasDifferent) {
            this.$message.warning('请选择同项目的人员')
          } else {
            this.clearEleForm();
            this.templatesByProjectList();
            let list = []
            this.multipleSelection.forEach((element, index) => {
              let data = {
                name: element.strEmpName,
                JobName: element.strJobInf,
                DtEntryBdate: element.dtEntryBdate,
                PhoneNum: element.strPhoneNum,
                StrIdCard: element.strIdCard,
                EmergencyPhone: '',
                EmergencyContact: '',
                Gender: '',
                StrEduLvl: element.strEduLv,
                Bankcard: element.strBankCard,
                DepositBank: element.strBankName,
                EmpContactAddress: element.strNativeAddr, //户籍地址
                StrDep: '', //部门
                TrialPeriodDec: '', ///试用期工资 金额
                StrReasonzh: '', //暂缓缴纳原因
                SubsidyAmount: '', //补贴金额
                SubsidyInstru: '',
                WorkingDay: '',
                StrPsnEmail: '', //个人电子邮箱
                StrPsnWx: '', //个人微信号
                StrPsnQq: '', //个人QQ
                StrEmContact: '', //紧急联系人
                StrEmContactPhone: '', //紧急联系人电话
                StrEmContactEmail: '', //紧急联系人邮箱
                StrEmContactAddr: '', //紧急联系人地址
                StrInterDurMonths: '', //月岗位工资
                StrReasonLeaving: '', //月绩效工资
                StrWorkHours: '', //税前基本工资
                StrInterDurMonths: '', //税前月岗位津贴
                LegalFeesAmountWords: '',
                LegalFeesAmount: '',
                ConfiPeriod: '',
              }
              list.push(data)
              if (this.multipleSelection.length == index + 1) {
                this.$set(this.eleForm, 'list', list);
                this.eleForm.ObjName = this.multipleSelection[0].strObjName
                console.log(this.eleForm)
                // console.log(this.eleForm.list)
              }
            });
            this.showEleInfo = true;
          }
        }
      },
      //取签约主体列表
      getLegalSubjectList() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })
      },
      //初始化电子签约信息表单
      clearEleForm() {
        this.tempType = '';
        this.StrCustName = '';
        this.eleForm = this.$options.data.call(this).eleForm
      },
      //根据项目查已配置好的模板列表
      templatesByProjectList() {
        xz.templatesByProjectList(this.multipleSelection[0].strObjName, this.roletype).then(res => {
          if (res.status == 'ok') {
            console.log(res.data)
            this.tempList = res.data.tempList;
            this.StrCustName = res.data.StrCustName;
          }
        })
      },
      //选择主体
      changeLeg(val, list) {
        if (val) {
          xz.getLegalSubjec(val).then(res => {
            if (res.status == 'ok') {
              this.$set(this.eleForm, 'LegalPer', res.data.LegalPerson)
              this.$set(this.eleForm, 'RegisterAddress', res.data.RegisteredAddress.indexOf('$$') > -1 ? res.data.RegisteredAddress.replace('$$', '') : res.data.RegisteredAddress)
              this.$set(this.eleForm, 'TaxNum', res.data.TaxNum)
            } else {
              this.$message.error('获取主体信息出错')
            }
          })
        } else {
          this.$set(this.eleForm, 'LegalPer', '')
          this.$set(this.eleForm, 'RegisterAddress', '')
        }
      },
      //选择合同/协议
      changeCont(val, list) {
        this[list].ProtocolType = val.name;
        this.contractType = val.val;
        this.jobNameLabel = val.jobNameLabel;
        this.no = val.no;
        if (this.eleForm.list.length == 1 && (this.no == 16 || this.no == 20 || this.no == 21 || this.no == 24 || this.no == 26 || this.no == 27 || this.no == 28 || this.no == 29)) {
          let str = `?strIdCard=${this.eleForm.list[0].StrIdCard}`
          xz.ArdCurStatGetFun('GetNewContractTimebyCardId', str).then(res => {
            if (res.status == 'ok') {
              try {
                this[list].ContractStartTime = res.data.dtContractBtime;
                if (this.no != 26) {
                  this[list].ContractEndTime = res.data.dtContractTime;
                }
              } catch (e) {}
            }
          })
        }
      },
      getEndDate(list) {
        this[list].TrialMonth = Number(this[list].TrialMonth)
        if (this[list].TrialMonth > 0 && Number.isInteger(this[list].TrialMonth)) {
          this[list].TrialPeriodEndTime = moment(this[list].TrialPeriodStartTime).add(this[list].TrialMonth, 'months').format('YYYY-MM-DD');
          this[list].TrialPeriodEndTime = moment(this[list].TrialPeriodEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
        if (this[list].TrialMonth > 6) {
          this.$message.warning('当前试用期已超过6个月，请核对！');
        }
      },
      getContractEndDate(val, list) {
        if (val >= 1) {
          if (this.no == 30 || this.no == 33) {
            this[list].ContractEndTime = moment(this[list].ContractStartTime).add(val, 'months').format('YYYY-MM-DD');
          } else {
            this[list].ContractEndTime = moment(this[list].ContractStartTime).add(val, 'years').format('YYYY-MM-DD');
          }
          this[list].ContractEndTime = moment(this[list].ContractEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
      },
      //计算工作时长
      changeTimeLaborContract(list, val) {
        let m1 = this[list].list[0].DtEntryBdate;
        let m2 = this[list].TimeLaborContract + ' 00:00:00';
        let diff = moment.preciseDiff(m1, m2, true);
        console.log(diff)
        this[list].WorkingYear = diff.years;
        this[list].WorkingMonth = diff.months;
        this[list].WorkingDay = diff.days + 1;
        this[list].TimeLaborContractStaff = val;
      },
      changeTemp2(val) {
        console.log(val)
        this.tempName = val.TempName;
        this.eleForm.tempid = val.TempId;
      },
      confirmToEle() {
        this.$refs["eleForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            console.log(this.eleForm)
            xz.submitESigningInfo(this.eleForm, localStorage.loginRoletype).then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.$message.success('保存成功！')
                this.getList()
                this.multipleSelection = [];
                this.showEleInfo = false;
              } else if (res.status == 'Resubmit') {
                this.submitMsg = res.msg
                this.showResubmit = true;
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg)
              }

            })
          }
        })
      },
      //参数列表（招聘来源 118）
      getdictdatalistbyid(id) {
        xz.getdictdatalistbyid(id).then(res => {
          if (res.status == 'ok') {
            this.blackLabelList = res.data.retList
          }
        })
      },
      cancelSubmit() {
        this.showResubmit = false;
        this.showEleInfo = false;
      },
      forceSubmit() {
        let d = JSON.parse(JSON.stringify(this.eleForm));
        d.Resubmit = '1';
        xz.submitESigningInfo(d, localStorage.loginRoletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功！')
            this.getList()
            this.showEleInfo = false;
            this.showResubmit = false;
            this.multipleEleSelection = []
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      OfflineSigning(row) {
        this.offRegForm = {
          Id: '',
          Name: row.strEmpName,
          PhoneNum: row.strPhoneNum,
          StrObjName: row.strObjName, //项目名称
          StrIdCard: row.strIdCard, //身份证
          TempType: '', //签约类型
          ContractSubject: '', //员工签约主体
          SignatureTime: '', //合同签约时间
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          dtEntryBDate: row.dtInsertDate, //入职日期
          AttachUrl: '', //合同附件
        }
        this.isBtnLoading = false;
        this.showOfflineSigning = true;
      },
      //上传附件
      success_handle(file, fileList) {
        console.log(file, fileList);
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.offRegForm.AttachUrl = res
          } else {
            this.offRegForm.AttachUrl = ''
          }
        });
      },
      handleRemove(file) {
        this.offRegForm.AttachUrl = ''
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 1 个文件`);
      },
      confirmOfflineSigning() {
        this.$refs["offRegForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.addOfflineSigning(this.offRegForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('线下签约登记成功！');
                this.isBtnLoading = false;
                this.showOfflineSigning = false;
              } else {
                this.$message.error(res.msg)
                this.isBtnLoading = false;
                this.showOfflineSigning = false;
              }
            })
          }
        })
      },
      insDialogHandle(type, act) {
        window.location.href = "/declare?currAct=" + act;
      },
      changeTurnOverTime(val) {
        console.log(val)
        this.quitList.forEach(element => {
          this.$set(element, 'dtDepartureDate', val)
        });
      },
      changeTurnOverTimereal(val) {
        this.quitList.forEach(element => {
          this.$set(element, 'dtRealDepartureDate', val)
        });
      },
      changeStrWorkState(val) {
        this.quitList.forEach(element => {
          this.$set(element, 'strWorkState', val)
        });
      },
      changeIsBlack(val) {
        this.quitList.forEach(element => {
          this.$set(element, 'strBlacklistReason', val)
        });
      },
      reduction(list) {
        if (this[list].length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          let canReduct = true;
          let hasMore = false;
          let errName = '';
          let arr = [];
          this[list].forEach((e, index) => {
            if (e.isInsured == '否') {
              canReduct = false;
            }
            if (e.insuredId != undefined && e.insuredId.length > 1) {
              hasMore = true;
              errName = e.strEmpName;
            } else if (e.insuredId != undefined && e.insuredId.length == 1) {
              let d = {
                Id: e.insuredId[0],
                ProjectName: e.strObjName
              }
              arr.push(d)
            }
            if (index == this[list].length - 1) {
              if (hasMore) {
                this.$message.error(errName + '有多个在保记录，请前往在保人员页面操作')
              } else if (!canReduct) {
                this.$message.warning('请选择在保的人员报减')
              } else if (canReduct) {
                this.isBtnLoading = true;
                xz.ReportReduce(arr, this.roletype).then(res => {
                  if (res.status == 'ok') {
                    this.$message.success('报减成功！');
                    this.isBtnLoading = false;
                    this.showReduction = false;
                    this.showQuitSign = false;
                    if (res.warnMsg) {
                      this.warnMsg = res.warnMsg;
                      this.showWarnMsg = true;
                    }
                  } else {
                    this.$message.error(res.msg);
                    this.isBtnLoading = false;
                  }
                })
              }
            }
          });

        }
      },
      printHandel(row) {
        let dd = {
          type: 2, //类型1：流程2：花名册
          processIds: [],
          baseKeys: [{
            strExcelPath: row.strExcelPath,
            intExcelLine: row.intExcelLine
          }]
        }
        this.GetPrintData(dd);
      },
      batchPrint() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(e => {
            let d = {
              strExcelPath: e.strExcelPath,
              intExcelLine: e.intExcelLine
            }
            arr.push(d)
          });

          let dd = {
            type: 2, //类型1：流程2：花名册
            processIds: [],
            baseKeys: arr
          }
          this.GetPrintData(dd)
        } else {
          this.$message.warning('请至少选择一条数据打印')
        }
      },
      GetPrintData(d) {
        xz.rcFun(d, 'InterviewOnboarding/GetPrintData').then(res => {
          if (res.status == 'ok') {
            res.data.forEach(ee => {
              ee.checked = false;
              ee.checked2 = false;
              if (ee.householdFoodSupply == '农') {
                ee.checked = true;
              } else if (ee.householdFoodSupply == '居') {
                ee.checked2 = true;
              }
              ee.checkList = [];
              if (ee.politicalAffiliation) {
                ee.checkList.push(ee.politicalAffiliation)
              }
              if (ee.educational.length < 3) {
                // 修复：每次都创建新对象而不是复用同一个对象
                while (ee.educational.length < 3) {
                  ee.educational.push({
                    startEndTime: '',
                    schoolName: '',
                    professional: '',
                    remark: ''
                  });
                }
              }
              if (ee.work.length < 3) {
                // 修复：每次都创建新对象而不是复用同一个对象
                while (ee.work.length < 3) {
                  ee.work.push({
                    startingWorkDate: '',
                    resignationDate: '',
                    organization: '',
                    position: '',
                    resignationReason: ''
                  });
                }
              }
              if (ee.member.length < 3) {
                // 修复：每次都创建新对象而不是复用同一个对象
                while (ee.member.length < 3) {
                  ee.member.push({
                    relationship: '',
                    name: '',
                    birthDate: '',
                    workplace: '',
                    position: '',
                    telephone: ''
                  });
                }
              }
            });
            this.printList = res.data;
            this.showPrint = true;
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      //计算生日 年龄 性别
      getBirth(iden) {
        iden = iden.replace(/\s/g, '');
        let age;
        let sexnum = null;
        let sex = null;
        let myDate = new Date();
        let month = myDate.getMonth() + 1;
        var day = myDate.getDate();
        sexnum = iden.substring(16, 17);
        if (sexnum % 2 === 0) {
          sex = "女";
        } else {
          sex = "男";
        }
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;
        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        )
          age++;
        var birth = iden.substring(6, 10) + "-" + iden.substring(10, 12);
        var arr = [];
        arr.push(age, birth, sex);
        return (arr)
      },
      expList() {
        // if (this.fixedfields.length == 0) {
        //   this.getImportFiledList()
        // }
        // if (this.listQuery.objname) {
        //   this.dialogVisible4 = true;
        // } else {
        //   this.getlastExportList();
        // }
        let d = JSON.parse(JSON.stringify(this.listQuery));
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(e => {
            let d = {
              strExcelPath: e.strExcelPath,
              intExcelLine: e.intExcelLine
            }
            arr.push(d)
          });
          d.selectIds = arr;
        }
        delete d.pagination;
        d.filename = `${this.activeName}列表导出.xlsx`;
        this.isExping = true;
        xz.rcFun(d, 'InterviewOnboarding/ReportEmployeeData/download').then(res => {
          if (res.status == 'ok') {
            setTimeout(() => {
              this.isExping = false;
              // this.$router.push({
              //   path: "/resImportList",
              //   query: {
              //     showPage: 1,
              //     isActive: 1,
              //     custname: '',
              //   },
              // });
              this.$store.dispatch('triggerRefresh');
            }, 1000);
          } else {
            this.isExping = false;
            this.$message.error(res.msg);
          }
        })
      },
      //获取最新一条导出记录
      async getlastExportList() {
        xz.bgetlastimpdata("全员导出").then((res) => {
          if (res && res != "没有记录！") {
            if (
              new Date().getTime() < new Date(res.DtImpDate).getTime() + 360000 &&
              this.isNull(res.StrOutPath)
            ) {
              this.$message({
                showClose: true,
                message: "全员导出一次后需六分钟后才能再导出，请稍后再导",
                type: "warning",
              });
            } else {
              this.dialogVisible4 = true;
            }
          } else {
            this.dialogVisible4 = true;
          }
        });
      },
      //全员导出字段全选
      handleCheckAllChange(val) {
        // this.tableclumn = this.allFieldList;
        this.checkedFields = val ? this.allFieldNameList : [];
        this.tableclumn1 = val ? this.allFieldList : [];
        if (val == false) {
          this.tableclumn1 = [{
            colname: "StrIdCard",
            name: "身份证号码",
            intOrderId: 13,
            strtype: '1'
          }, ];
        }
        this.isIndeterminate = false;
        this.tableclumn = this.tableclumn1.concat(this.tableclumn2);
        // console.log('选择的字段', this.tableclumn)
      },
      //全员导出字段选择
      handleCheckedCitiesChange(value) {
        this.tableclumn1 = [{
          colname: "StrIdCard",
          name: "身份证号码",
          intOrderId: 13,
          strtype: '1'
        }];
        for (let index = 0; index < this.allFieldList.length; index++) {
          if (value != "" && value != null) {
            for (let i = 0; i < value.length; i++) {
              if (value[i] == this.allFieldList[index].name) {
                this.tableclumn1.push(this.allFieldList[index]);
              }
            }
          } else {
            this.tableclumn1 = [{
              colname: "StrIdCard",
              name: "身份证号码",
              intOrderId: 13,
              strtype: '1'
            }, ];
          }
        }
        //去重
        this.tableclumn1 = this.unique(this.tableclumn1);
        this.tableclumn = this.tableclumn1.concat(this.tableclumn2);
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.allFieldNameList.length;
        this.isIndeterminate =
          checkedCount > 0 && checkedCount < this.allFieldNameList.length;
      },
      //去重
      unique(arr) {
        const resList = new Map();
        return arr.filter(
          (arr) => !resList.has(arr.name) && resList.set(arr.name, 1)
        );
      },
      //获取固定字段
      getImportFiledList() {
        this.fixedfields = [];
        xz.getJbbasePageColumnList('JB_emp_UserBaseout', '').then((res) => {
          if (res && res.msg.length > 0) {
            for (let index = 0; index < res.msg.length; index++) {
              const elementRes = res.msg[index];
              this.fixedfields.push({
                name: elementRes.StrColumName,
                colname: elementRes.StrColumId,
                intOrderId: elementRes.IntOrderId,
                strtype: '1'
              });
            }
            //去重
            this.allFieldList = JSON.parse(JSON.stringify(this.fixedfields));
            for (let index = 0; index < this.fixedfields.length; index++) {
              const elementData = this.fixedfields[index];
              this.allFieldNameList.push(elementData.name);
            }
          }
        });
      },
      changeExpObj(val) {
        if (val) {
          let item = this.proNameList.find(item => item.StrprojectName == val);
          xz.getJbbaseEmpColumnPro(item.Projectid).then((res) => {
            if (res.status == 'ok') {
              this.expandFieldList = [];
              for (let index = 0; index < res.msg.length; index++) {
                const elementRes = res.msg[index];
                this.expandFieldList.push({
                  name: elementRes.StrColumName,
                  colname: elementRes.StrColumId,
                  intOrderId: elementRes.IntOrderId,
                  strtype: '2'
                });
              }
              let arr = this.allFieldList.concat(this.expandFieldList);
              this.allFieldList = this.unique(arr);
              this.allFieldNameList = [];
              for (let index = 0; index < this.allFieldList.length; index++) {
                const elementData = this.allFieldList[index];
                this.allFieldNameList.push(elementData.name);
              }
            }
          });
        }
      },
      confirmExport() {
        if (!this.checkAll) {
          this.tableclumn.sort(function (a, b) {
            return a.intOrderId - b.intOrderId;
          });
        }
        console.log('this.tableclumn', this.tableclumn)
        const data = {
          custname: this.expObjname ? this.expObjname : "全员导出",
          strworkstate: this.workState,
          outtype: "1",
          tableid: "JB_emp_UserBaseout",
          roletype: localStorage.loginRoletype,
          expireWarn: this.listQuery.expireWarn,
          isSign: this.listQuery.isSign,
          isInsure: this.listQuery.isInsure,
          StrInsuranceType: this.listQuery.StrInsuranceType,
          strEmpName: this.listQuery.strEmpName,
          strPhoneNum: this.listQuery.strPhoneNum,
          strIdCard: this.listQuery.strIdCard,
          tableclumn: this.tableclumn,
        };
        console.log('导出', data)
        let Promise = xz.OutExcel(data, this.roletype);
        this.$router.push({
          path: "/resImportList",
          query: {
            showPage: 1,
            isActive: 1,
            custname: this.listQuery.objname ? this.listQuery.objname : "全员导出",
            //qStstus=1时查看最后一条导出记录
            // qStstus: 1,
          },
        });
      },
      // 跟进弹框
      followHandle(item) {
        this.matchQuery.ResumeId = item.ResumeId
        this.followQuery.resumeId = item.ResumeId
        this.serviceQuery.resumeId = item.ResumeId
        this.recommendQuery = {
          ResumeId: item.ResumeId, // 简历id
          StrUserJobhunt: '', // 求职意愿
          StrReason: '', // 原因
          StrRemark: '', // 备注
          GduserId: Cookies.get("userid-b"), // 操作人
          GduserName: '', // 操作人姓名
          StrOther: '', // 其他
          fCheckList: []
        }
        // 人岗匹配列表
        this.getMatchList()
        this.getFollowList()
        // 服务列表
        this.getServiceList()
        this.followVisible = true
      },
      // 人岗匹配列表
      getMatchList() {
        this.recommendLoading = true
        xz.wxappgetjoblist(this.roletype, this.matchQuery).then(res => {
          // console.log('getMatchList', res)
          if (res.status == 'ok') {
            this.recommendList = res.data.retList
            this.matchCount = res.data.count
          } else {
            this.recommendList = []
            this.matchCount = 0
          }
          this.recommendLoading = false
        })
      },
      //获取跟进记录
      getFollowList() {
        this.followLoading = true
        xz.getresumePsnfowrecords(this.followQuery).then(res => {
          // console.log('followQuery', res)
          if (res.status == 'ok') {
            this.followData = res.msg
            this.totalFollow = res.totalcount
          } else {
            this.followData = []
            this.totalFollow = 0
          }
          this.followLoading = false
        })
      },
      //获取服务记录 流程记录
      getServiceList() {
        this.serviceLoading = true
        xz.getresumePsnstatusrecords(this.serviceQuery).then(res => {
          // console.log('serviceQuery', res)
          if (res.status == 'ok') {
            this.serviceData = res.msg
            this.totalService = res.totalcount
          } else {
            this.serviceData = []
            this.totalService = 0
          }
          this.serviceLoading = false
        })
      },
      // 保存跟进
      saveFollowHandle() {
        this.$refs['followForm'].validate((valid) => {
          if (valid) {
            xz.savePsnfowrecords(this.recommendQuery).then(res => {
              // console.log('saveEnterHandle', res)
              if (res.status == 'ok') {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.getFollowList()
              } else {
                this.$message({
                  type: 'error',
                  message: '操作失败，请稍后再试'
                })
              }
            })
          } else {
            return false;
          }
        })
      },
      recommendCurrentChange(val) {
        this.matchQuery.pageNum = Number(val)
        this.getMatchList()
      },
      recommendSizeChange(val) {
        this.matchQuery.pageNum = 1
        this.matchQuery.pageSize = Number(val)
        this.getMatchList()
      },
      //分页(服务记录/跟进记录)
      handleCurrentChange1(val) {
        this.followQuery.currpage = Number(val)
        this.getFollowList()
      },
      handleSizeChange1(val) {
        this.followQuery.currpage = 1
        this.followQuery.perpage = Number(val)
        this.getFollowList()
      },
      handleCurrentChange2(val) {
        this.serviceQuery.currpage = Number(val)
        this.getServiceList()
      },
      handleSizeChange2(val) {
        this.serviceQuery.currpage = 1
        this.serviceQuery.perpage = Number(val)
        this.getServiceList()
      },
      // 标签弹框
      labelHandle(item) {
        this.resumeIds = item.ResumeId
        this.getresumelabelLists(item.ResumeId)
        this.labelVisible = true
      },
      // 获取简历标签详情
      getresumelabelLists(resumeId) {
        this.includePublicChecks = []
        this.includePrivateChecks = []
        xz.GetresumelabelLists({
          resumeId: resumeId
        }).then(res => {
          // console.log('getresumelabelLists', res)
          if (res.status == 'ok') {
            this.lPubDialogList = res.msgpub
            this.lPriDialogList = res.msgpri
            // 公共标签
            if (!this.isNull(res.msgpub)) {
              for (let i = 0; i < res.msgpub.length; i++) {
                const elementpub = res.msgpub[i];
                this.enTagChecks.push(elementpub.LabelId)
                this.includePublicChecks.push(elementpub.LabelId)
              }
            }
            // 私有标签
            if (!this.isNull(res.msgpri)) {
              for (let j = 0; j < res.msgpri.length; j++) {
                const elementpri = res.msgpri[j];
                this.enTagChecks.push(elementpri.LabelId)
                this.includePrivateChecks.push(elementpri.LabelId)
              }
            }
          }
        })
      },
      // 添加标签弹框
      addLabelHandle() {
        // 全局标签
        for (let i = 0; i < this.lPubDialogList.length; i++) {
          const elementl1 = this.lPubDialogList[i];
          this.wholeCheckList.push(elementl1.LabelId)
        }
        // 私有
        for (let j = 0; j < this.lPriDialogList.length; j++) {
          const elementl2 = this.lPriDialogList[j];
          this.wholeCheckList2.push(elementl2.LabelId)
        }
        this.dCheckPriLabelList = this.wholeCheckList2
        this.dCheckCommonLabelList = this.wholeCheckList
        this.diaTagChecks = this.wholeCheckList.concat(this.wholeCheckList2)
        // console.log('rrr',this.wholeCheckList,this.wholeCheckList2)
        this.addlabelVisible = true
      },
      // 保存编辑标签
      saveLabelHandle() {
        this.diaTagChecks = this.dCheckPriLabelList.concat(this.dCheckCommonLabelList)
        //去重
        this.diaTagChecks = [...new Set(this.diaTagChecks)];
        let ids = this.diaTagChecks.toString()
        // console.log('uuu',this.resumeIds,this.diaTagChecks)
        if (this.isNull(this.diaTagChecks)) {
          this.$message({
            type: 'warning',
            message: '请选择标签'
          })
          return false
        } else {
          this.tagHandle({
            resumeIds: this.resumeIds,
            labelIds: ids
          }, 'dialog')
          // this.getList()
        }
      },
      //获取所有标签列表
      GetLabelManagement() {
        this.laloading = true;
        this.publicList = []
        this.privateList = []
        this.allLabelList = []
        let labelList = []
        xz.GetLabelManagement(this.roletype).then(res => {
          // console.log('所有', res)
          if (res.status == 'ok') {
            this.publicList = res.data.PublicPersonList;
            this.privateList = res.data.PrivatelyList;
          }
          this.laloading = false;
        })
      },
      // 标签弹框 选择公有标签
      dPubEnterHandle(val) {
        this.dCheckCommonLabelList = []
        this.dCheckCommonLabelList = val
      },
      // 标签弹框 选择私有标签
      dPraEnterHandle(val) {
        this.dCheckPriLabelList = []
        this.dCheckPriLabelList = val
      },
      // 打标签
      tagHandle(query, type) {
        xz.savelabelResume(query).then(res => {
          if (res.status == 'ok') {
            if (type == 'dialog') {
              this.getresumelabelLists(query.resumeIds)
              this.addlabelVisible = false
            }
            if (type == 'enter') {
              this.enterResumeVisible = false
            }
            this.$message({
              type: 'success',
              message: '操作成功'
            })
          } else {
            this.$message({
              type: 'error',
              message: '操作失败,请稍后再试'
            })
          }
        })
      },
      //入职登记
      entryHandel() {
        const routerUrl = this.$router.resolve({
          path: "/rosterEmpEdit",
          query: {
            type: 'entry'
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      // 导入弹框
      importHandle(type) {
        this.importVisible = true
        this.importSignQuery.projectid = ''
        this.importSignQuery.strprojectName = ''
        this.importSignQuery.jobid = ''
        this.importSignQuery.customerJobName = ''
        this.errorTxt = ''
        this.excelpath = ''
        this.importActive = 0
        this.ExcelSrc = {
          value: '',
          check: false,
          fileName: ''
        }
        this.isUploadSuccess = true
        this.importPostList = []
        if (type == 'third') {
          this.importStrState = '入职'
          this.importName = '批量入职（全量）导入'
          this.importSignQuery.tabName = '批量导入入职模板（全量）'
          this.importSignQuery.fileid = '批量导入入职模板（全量）'
          this.importSignQuery.tableid = 'JB_emp_UserBase'
          // this.downSignQuery.tableid = 'RPA_output_JB_emp_UserBase'
          this.downSignQuery.tableid = 'output_JB_emp_UserBase'
          if (window.localStorage.getItem('isJobDownload')) {
            this.calDaysBetween(window.localStorage.getItem('isJobDownload'))
          }
        } else if (type == 'thirdzz') {
          this.importStrState = '入职'
          this.importName = '批量入职导入'
          this.importSignQuery.tabName = '批量入职模板（简易）'
          this.importSignQuery.fileid = '批量入职模板（简易）'
          this.importSignQuery.tableid = 'JB_emp_UserBaseSimple'
          // this.downSignQuery.tableid = 'RPA_output_JB_emp_UserBase'
          this.downSignQuery.tableid = 'output_JB_emp_UserBaseSimple'
          if (window.localStorage.getItem('isJobDownloadzz')) {
            this.calDaysBetween(window.localStorage.getItem('isJobDownloadzz'))
          }
        } else if (type == 'four') {
          this.importStrState = '离职'
          this.importName = '批量导入离职模板'
          this.importSignQuery.tabName = '批量导入离职模板'
          this.importSignQuery.fileid = '批量导入离职模板'
          this.importSignQuery.tableid = 'JB_emp_UserBaseDepart'
          this.downSignQuery.tableid = 'output_JB_emp_UserBaseDepart'
          if (window.localStorage.getItem('isDepartDownload')) {
            this.calDaysBetween(window.localStorage.getItem('isDepartDownload'))
          }
        } else if (type == 'five') {
          this.importStrState = '信息维护'
          this.importName = '信息维护导入'
          this.importSignQuery.tabName = '花名册信息维护模板'
          this.importSignQuery.fileid = '花名册信息维护模板'
          this.importSignQuery.tableid = 'JB_emp_UserBaseMainte'
          // this.downSignQuery.tableid = 'RPA_output_JB_emp_UserBase'
          this.downSignQuery.tableid = 'output_JB_emp_UserBaseMainte'
          if (window.localStorage.getItem('isMaintenance')) {
            this.calDaysBetween(window.localStorage.getItem('isMaintenance'))
          }
        }
      },
      calDaysBetween(date) {
        let startDate = Date.parse(date);
        let endDate = Date.parse(new Date());
        let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        // console.log('ddd',days,'ggg',date)
        if (days > 7) {
          if (this.importSignQuery.tabName == '花名册信息维护模板') {
            this.isMaintenance = false;
          }
          if (this.importSignQuery.tabName == '批量导入离职模板') {
            this.isDepartDownload = false;
          }
          if (this.importSignQuery.tabName == '批量导入入职模板（全量）') {
            this.isJobDownload = false;
          }
          if (this.importSignQuery.tabName == '批量入职模板（简易）') {
            this.isJobDownloadzz = false;
          }
        } else {
          // console.log('ff', this.importSignQuery.tabName)
          if (this.importSignQuery.tabName == '花名册信息维护模板') {
            this.isMaintenance = true;
          }
          if (this.importSignQuery.tabName == '批量导入离职模板') {
            this.isDepartDownload = true;
          }
          if (this.importSignQuery.tabName == '批量导入入职模板（全量）') {
            this.isJobDownload = true;
          }
          if (this.importSignQuery.tabName == '批量入职模板（简易）') {
            this.isJobDownloadzz = true;
          }
        }
      },
      // 导入选择项目
      impProChange(val) {
        let that = this
        that.importSignQuery.jobid = ''
        if (!this.isNull(val)) {
          let obj = {};
          obj = this.searchProList.find((item) => {
            return item.Projectid === val;
          });
          console.log('hh', val)
          this.importSignQuery.strprojectName = obj.StrprojectName
          this.stateInfoQuery.strobjname = obj.StrprojectName
          this.getresourcejobcategoryblist(obj.Projectid, 'import')
        } else {
          this.importSignQuery.strprojectName = ''
          this.importSignQuery.projectid = ''
          this.importPostList = []
          this.importSignQuery.jobid = ''
        }
      },
      //获取搜索中的岗位列表
      getresourcejobcategoryblist(id, type) {
        xz.getresourcejobcustomerlist(localStorage.loginRoletype, {
          projectid: id.toString()
        }).then(res => {
          // console.log('searPostList', res)
          if (res.status == 'ok') {
            if (type == 'search') {
              this.searPostList = res.data;
            }
            if (type == 'import') {
              this.impJobList = res.data;
            }
          } else {
            if (type == 'search') {
              this.searPostList = [];
            }
            if (type == 'import') {
              this.impJobList = res.data;
            }
          }
        })
      },
      //查询导入状态(在职导入)
      queryImportState() {
        let that = this
        xz.getPsnImpDataList(this.stateInfoQuery).then((res) => {
          if (res) {
            if (res.msg && res.msg.data.length > 0) {
              let results = res.msg.data
              let opTime = results[0].DtImpDate.replace('T', ' ');
              if ((new Date().getTime() > new Date((new Date(opTime)).valueOf() + 360000).getTime()) || results[0].StrImpEdateStr == '100') {
                that.importActive += 1
              } else {
                this.$message({
                  message: '您有一条正在导入的记录，请在导入完成后再导入',
                  duration: 5000,
                  type: 'warning'
                })
              }
            } else {
              that.importActive += 1
            }
          } else {
            this.$message.error("系统出错，请联系管理员");
          }
        })
      },
      // 获取导入岗位列表
      getImportPostList(projectid) {
        this.importPostList = []
        if (!this.isNull(this.allPostList)) {
          for (let i = 0; i < this.allPostList.length; i++) {
            let element07 = this.allPostList[i];
            if (element07.Projectid == projectid) {
              this.importPostList.push({
                Id: element07.Id,
                CustomerJobName: element07.CustomerJobName
              })
            }
          }
        }
      },
      // 导入选择岗位
      impPostChange(val) {
        let that = this
        if (!this.isNull(val)) {
          let obj = {};
          obj = this.impJobList.find((item) => {
            return item.Id === val;
          });
          this.importSignQuery.customerJobName = obj.CustomerJobName
        } else {
          this.importSignQuery.customerJobName = ''
          this.importSignQuery.jobid = ''
        }
      },
      //下载模板
      downLoadHandle() {
        let that = this;
        xz.getImportModeUrl(this.downSignQuery.tableid, this.importSignQuery.fileid).then(res => {
          // console.log('下载模板', res)
          if (res.status == 'ok') {
            if (that.importSignQuery.tabName == '批量导入离职模板') {
              that.isDepartDownload = true;
              window.localStorage.setItem('isDepartDownload', new Date());
            }
            if (that.importSignQuery.tabName == '批量导入入职模板（全量）') {
              that.isJobDownload = true;
              window.localStorage.setItem('isJobDownload', new Date());
            }
            if (that.importSignQuery.tabName == '花名册信息维护模板') {
              that.isMaintenance = true;
              window.localStorage.setItem('isMaintenance', new Date());
            }
            if (that.importSignQuery.tabName == '批量入职模板（简易）') {
              that.isJobDownloadzz = true;
              window.localStorage.setItem('isJobDownloadzz', new Date());
            }
            let d = res.msg.data.StrOutPath
            d = d.replace("\"", "").replace("\"", "")
            var path = that.tablePath + d
            let aTag = document.createElement('a')
            aTag.download = this.importSignQuery.tabName + '.xlsx';
            aTag.href = path
            aTag.click();
          }
        })
      },
      //文件读取
      async importf() {
        let fileInput = this.$refs.upload;
        this.excelpath = ''
        FUN.returnExcelSrc(fileInput).then(src => {
          if (src) {
            // console.log('src0o0', src)
            this.isFileSuccess = true
            this.$set(this.ExcelSrc, "value", src.src);
            this.$set(this.ExcelSrc, "check", false);
            this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
            // console.log('srccc', this.ExcelSrc)
            //上传excel
            let excelFile = FUN.base64ToFile(this.ExcelSrc.value, this.ExcelSrc.fileName);
            let formData = new FormData();
            formData.append("pagename", 'empexcel');
            formData.append("action", 'save');
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", Cookies.get("userid-b"));
            formData.append("excel", excelFile, this.ExcelSrc.fileName);
            // console.log('formData', formData)
            xz.uploadCert(formData).then(res => {
              // console.log('formData', res)
              if (this.isNull(res) || res == false) {
                this.$message('上传Excel失败!')
                this.isUploadSuccess = true
              } else {
                this.errorTxt = ''
                this.excelpath = res;
                this.isUploadSuccess = false
              }
            });
          } else {
            this.$message('上传Excel失败!')
          }
        })
      },
      //下一步导入
      nextSteps() {
        console.log(this.importSignQuery.tabName)
        let that = this
        if (this.importActive == 0) {
          if (this.isNull(this.importSignQuery.projectid)) {
            this.$message({
              message: "请选择项目",
              type: "warning",
              duration: 2000
            });
            return false
          }
          if (that.importSignQuery.jobid == '') {
            that.importSignQuery.jobid = 0
          }
          if (this.importSignQuery.tabName == '花名册信息维护模板') {
            if (!that.isMaintenance) {
              that.$message({
                message: "请先下载导入模板，下一步导入请使用新的模板导入",
                type: "warning",
                duration: 5000
              });
              return false
            }
            this.importActive += 1
            console.log(this.importActive)
          }
          if (this.importSignQuery.tabName == '批量导入离职模板') {
            if (!that.isDepartDownload) {
              that.$message({
                message: "请先下载导入模板，下一步导入请使用新的模板导入",
                type: "warning",
                duration: 5000
              });
              return false
            }
            this.importActive += 1
          }
          if (this.importSignQuery.tabName == '批量导入入职模板（全量）') {
            if (!that.isJobDownload) {
              that.$message({
                message: "请先下载导入模板，下一步导入请使用新的模板导入",
                type: "warning",
                duration: 5000
              });
              return false
            }
            that.queryImportState()
          }
          if (this.importSignQuery.tabName == '批量入职模板（简易）') {
            if (!that.isJobDownloadzz) {
              that.$message({
                message: "请先下载导入模板，下一步导入请使用新的模板导入",
                type: "warning",
                duration: 5000
              });
              return false
            }
            that.queryImportState()
          }
        }
      },
      //选择签约模板
      changeTemp(val) {
        let item = this.tempList.find(e => e.TempName == val)
        this.eleForm.tempid = item.TempId;
        this.tempType = item.TempType;
        this.TempName = item.TempName;
      },
      //上一步导入
      prevSteps() {
        this.importActive -= 1
      },
      //提交导入
      async lastSteps() {
        if (this.ExcelSrc.value == '') {
          this.isUploadSuccess = true
          this.$message({
            message: "请选择文件上传",
            type: "warning"
          });
          this.importActive = 1
          return false
        } else {
          //检查表头是否正确
          let checkData = {
            excelpath: this.excelpath,
            tableid: this.importSignQuery.tableid,
            fileid: this.importSignQuery.fileid,
            projectid: this.importSignQuery.projectid,
            strprojectName: this.importSignQuery.strprojectName
          }
          // console.log('checkData', checkData)
          this.fullscreenLoading = true;
          xz.chkPsnTableFormql(checkData).then(res => {
            // console.log('checkData',res.msg)
            let resultTxt = res.msg
            if (this.isNull(res.msg)) {
              this.isError = false
              this.isUploadSuccess = false
              let Edata = {
                instname: '',
                strState: this.importStrState, //状态
                tableid: this.importSignQuery.tableid,
                // impexcel:"简历导入表",
                reimp: this.reimp,
                excelpath: this.excelpath,
                impexcel: this.ExcelSrc.fileName,
                servusrname: '', // 负责客服
                servcentname: '', // 服务中心
                custname: '', // 客户简称
                fileid: this.importSignQuery.fileid,
                projectid: this.importSignQuery.projectid,
                strprojectName: this.importSignQuery.strprojectName, //选择的项目名称
                jobid: this.importSignQuery.jobid, //选择的岗位
                customerJobName: this.importSignQuery.customerJobName, //岗位名称
                roletype: this.roletype
                // IsRPAImport:'1'
              }
              xz.psnAnlysisExcelInfstatus(Edata).then(res => {
                // console.log('Edata', res)
                if (res.status == 'ok') {
                  this.importActive = 2
                } else {
                  this.$message('导入错误');
                }
                this.fullscreenLoading = false;
                // this.isUploadSuccess = true
              })
            } else {
              this.isError = true
              this.importActive = 1
              this.isUploadSuccess = true
              this.errorTxt = resultTxt
              //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
              //清空input file值
              let file = document.getElementById("fileInput");
              file.value = '';
              this.fullscreenLoading = false;
            }
          })
        }
      },
      // 查看导入结果
      resultHandle() {
        let act = 'third';
        if (this.importSignQuery.tabName == '批量导入离职模板') {
          act = 'four';
        } else if (this.importSignQuery.tabName == '批量导入入职模板（全量）' || this.importSignQuery.tabName == '批量入职模板（简易）' || this.importSignQuery.tabName == '花名册信息维护模板') {
          act = 'third';
        }
        this.$router.push({
          path: "/resImportList",
          query: {
            active: '导入导出记录',
            activeTab: act
          }
        })
      },
      //导入-确认返回
      backHandle() {
        this.importVisible = false
        this.listQuery.pagination.page = 1
        this.getList()
      },
      // 获取搜索项目列表(除在离职)
      getSearchProList() {
        let d = {
          searchVal: '',
          pageSize: 100000000,
          pageNum: 1
        }
        xz.getplancomrecordprojectlist(d, localStorage.loginRoletype).then(res => {
          // console.log('项目列表11', res)
          if (res.status == 'ok') {
            this.searchProList = res.data
          } else {
            this.searchProList = []
          }
        })
      },
      tableRowClassName(row) {
        if (row.IsMoreInCompay) {
          return 'warning-row';
        } else {
          return '';
        }
      },
      changeTab2() {
        if (this.activeName2 == '1') {
          this.$router.push({
            path: '/empRosterList?active=全量'
          });
        }
      },
      closePrint() {
        this.showPrint = false;
      },
      //在职tab切换
      handleClick() {
        this.getList()
      },
      //批量商保报增
      handleInsure() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          //判断是否选择了不同项目的人员
          this.batchJobName = '';
          this.batchJobClasss = '';
          this.batchEmployeeAttribute = '';
          this.batchLaborContractUnit = '';
          let name = this.multipleSelection[0].strObjName;
          let hasDifferent = this.multipleSelection.some(val => val.strObjName != name)
          let hasInsurance = this.multipleSelection.some(val => val.isInsured != '否'); //判断是否有已参保的 
          if (hasDifferent) {
            this.$message.warning('请选择同项目的人员')
          } else if (hasInsurance) {
            this.$message.warning('已参保的人员不能报增')
          } else {
            if (this.planList.length == 0) {
              this.getInsurancManageByUserid();
            }
            this.clearEleForm();
            let list = []
            this.multipleSelection.forEach((element, index) => {
              let data = {
                MainlinsuredName: element.strEmpName,
                MainlinsuredCardId: element.strIdCard,
                Idtype: '身份证', //证件类型
                MainlinsuredPhone: element.strPhoneNum,
                JobName: element.strJobInf, //岗位
                EmployeeAttribute: '', //员工属性
                JobClasss: '', //职业类别
                LaborContractUnit: '',
              }
              list.push(data)
              if (this.multipleSelection.length == index + 1) {
                this.$set(this.declareForm, 'userList', list)
                console.log(this.declareForm)
                this.declareForm.Insurance.ProjectName = this.multipleSelection[0].strObjName
                this.declareForm.Insurance.Projectid = this.multipleSelection[0].projectid
              }
            });
            this.showDeclare = true;
          }
        }
      },
      // 选择险种
      insChange(val) {
        if (!this.isNull(val)) {
          this.getPolicyList(val)
          this.getInsurancCategory(val)
        }
      },
      //取职业类别
      getInsurancCategory(Id) {
        xz.getInsurancManage(Id, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.JobClasssList = res.data.InsuranceManage.EmployeeAttribute.split(',');
          } else {
            // this.$message("获取险种列表出错!");
            this.JobClasssList = []
          }
        })
      },
      //获取可参保时间段列表
      getPolicyList(Id) {
        let data = {
          insurable: 1,
          pageNum: 1,
          InsuranceId: Id,
          pageSize: 1000,
        }
        xz.getOrderPolicyManageList(data, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.policyList = res.data.list;
          } else {
            this.policyList = []
          }
        })
      },
      policyChange(val) {
        this.declareForm.Insurance.OrderNum = val.OrderCode;
        this.declareForm.Insurance.InsuranceStartTime = val.CoverStartTime;
        this.declareForm.Insurance.InsuranceEndTime = val.CoverEndTime;
      },
      //取自己可取到险种
      getInsurancManageByUserid() {
        let data = {
          pageNum: 1,
          pageSize: 10000
        }
        xz.getInsurancManageByUserid(data, this.roleType).then(res => {
          if (res.status == 'ok') {
            this.planList = res.data.list;
          } else {
            // this.$message("获取险种列表出错!");
            this.planList = []
          }
        })
      },
      confirmToInsure() {
        this.$refs["declareForm"].validate((valid) => {
          if (valid) {
            xz.reportAddApprov(this.declareForm, this.roleType).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！');
                this.showDeclare = false;
              } else {
                this.$message.error(res.msg);
                this.showDeclare = false;
              }
            })
          }
        })
      },
      entryAgain(row) {
        const routerUrl = this.$router.resolve({
          path: "/rosterEmpEdit",
          query: {
            strExcelPath: row.strExcelPath,
            intExcelLine: row.intExcelLine,
            type: 'entryAgain'
          }
        });
        const newWindow = window.open(routerUrl.href, "_blank");
      },
      batchChangeJobName(val) {
        this.declareForm.userList.forEach(element => {
          this.$set(element, 'JobName', val);
        });
      },
      batchChangeJobClasss(val) {
        this.declareForm.userList.forEach(element => {
          this.$set(element, 'JobClasss', val);
        });
      },
      batchChangeEmployeeAttribute(val) {
        this.declareForm.userList.forEach(element => {
          this.$set(element, 'EmployeeAttribute', val);
        });
      },
      batchChangeLaborContractUnit(val) {
        this.declareForm.userList.forEach(element => {
          this.$set(element, 'LaborContractUnit', val);
        });
      },
      expAllList() {
        let d = JSON.parse(JSON.stringify(this.listQuery));
        delete d.pagination;
        d.filename = `全量导出.xlsx`;
        this.isExping2 = true;
        xz.rcFun(d, 'InterviewOnboarding/ExportFullVolume/download').then(res => {
          if (res.status == 'ok') {
            setTimeout(() => {
              this.isExping2 = false;
              this.$router.push({
                path: "/resImportList",
                query: {
                  showPage: 1,
                  isActive: 1,
                  custname: '',
                },
              });
            }, 1000);
          } else {
            this.isExping2 = false;
            this.$message.error(res.msg);
          }
        })
      },
      //续签
      renew(row) {
        let d = {
          strExcelPath: row.strExcelPath,
          intExcelLine: row.intExcelLine
        }
        xz.rcFun(d, 'InterviewOnboarding/GetElectronicSignatureEdit').then(res => {
          if (res.status == 'ok') {
            if (res.data == undefined || res.data == null) {
              this.eleForm.tempid = '';
              this.tempType = '';
              this.TempName = '';
              this.multipleSelection = [row];
              this.enterSignHandle()
            } else {
              xz.templatesByProjectList(res.data.objName, this.roletype).then(r => {
                if (r.status == 'ok') {
                  this.tempList = r.data.tempList;
                  this.StrCustName = r.data.StrCustName;
                  let item2 = this.tempList.find(e => e.TempId == res.data.tempId)
                  this.tempType = item2.TempType;
                  this.TempName = item2.TempName;
                }
              })
              let item = this.contractList.find(e => e.name == res.data.protocolType)
              this.contractType = item.val;
              this.jobNameLabel = item.jobNameLabel;
              this.no = item.no;
              this.eleForm = {
                tempid: res.data.tempId, //模板id
                ObjName: res.data.objName,
                ContractSubject: res.data.contractSubject, //员工签约主体
                LegalPer: res.data.legalPer, //法人
                RegisterAddress: res.data.registerAddress, //注册地址
                TaxNum: '',
                TaxCity: '',
                ContractStartTime: '', //合同开始时间
                ContractEndTime: '', //合同结束时间
                TrialPeriodStartTime: '', //试用期开始时间
                TrialPeriodEndTime: '', //试用期结束时间
                TrialMonth: '', //试用期时长
                ProtocolType: res.data.protocolType, //合同/协议类型
                JobName: res.data.jobName, //岗位
                WorkSite: res.data.workSite, //工作地点
                SchoolName: res.data.schoolName, //学校
                Bankcard: res.data.bankcard, //银行卡号
                DepositBank: res.data.depositBank, //开户银行
                WorkingYear: res.data.workingYear, //工作时长(年)
                WorkingMonth: res.data.workingMonth, //工作时长(月)
                WorkingDay: res.data.workingDay, //工作时长(天)
                TimeLaborContract: res.data.timeLaborContract, //终止（解除）劳动合同时间
                TimeLaborContractStaff: res.data.timeLaborContractStaff, //终止（解除）劳动合同时间（员工联）
                StrEduLvl: res.data.strEduLvl, //文化程度
                EmpContactAddress: res.data.empContactAddress, //联系地址
                MeansOfPayments: res.data.meansOfPayments, //工资标准方式
                PayDay: res.data.payDay,
                Yuan: res.data.yuan,
                WorkCity: res.data.workCity,
                WorkTime: res.data.workTime,
                list: [{
                  name: res.data.name,
                  PhoneNum: res.data.phoneNum,
                  StrIdCard: res.data.strIdCard,
                  DtEntryBdate: res.data.dtEntryBDate, //入职日期
                  JobName: res.data.jobName, //岗位
                  StrEduLvl: res.data.strEduLvl, //文化程度
                  ClientFullName: res.data.clientFullName,
                  EmpContactAddress: res.data.empContactAddress, //联系地址
                  Bankcard: res.data.bankcard, //银行卡号
                  DepositBank: res.data.depositBank, //开户银行
                  EmpContactAddress: res.data.empContactAddress, //户籍地址
                  StrDep: res.data.strDep, //部门
                  TrialPeriodDec: res.data.trialPeriodDec, ///试用期工资 金额
                  StrReasonzh: res.data.strReasonzh, //暂缓缴纳原因
                  SubsidyAmount: res.data.subsidyAmount, //补贴金额
                  SubsidyInstru: res.data.subsidyInstru,
                  WorkingDay: res.data.workingDay,
                  StrPsnEmail: res.data.strPsnEmail, //个人电子邮箱
                  StrPsnWx: res.data.strPsnWX, //个人微信号
                  StrPsnQq: res.data.strPsnQQ, //个人QQ
                  StrEmContact: res.data.strEmContact, //紧急联系人
                  StrEmContactPhone: res.data.strEmContactPhone, //紧急联系人电话
                  StrEmContactEmail: res.data.strEmContactEmail, //紧急联系人邮箱
                  StrEmContactAddr: res.data.strEmContactAddr, //紧急联系人地址
                  StrInterDurMonths: res.data.strInterDurMonths, //月岗位工资
                  StrReasonLeaving: res.data.strReasonLeaving, //月绩效工资
                  StrWorkHours: res.data.strWorkHours, //税前基本工资
                  StrInterDurMonths: res.data.strInterDurMonths, //税前月岗位津贴
                  Remark1: res.data.remark1,
                  Remark2: res.data.remark2,
                  Remark3: res.data.remark3,
                  LegalFeesAmountWords: '',
                  LegalFeesAmount: '',
                  ConfiPeriod: ''
                }]
              }
              this.showEleInfo = true;
            }
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      searchHandle() {
        this.listQuery.pagination.Page = 1;
        this.getList();
      },
      getChannels(val) {
        const item = this.ChannelsList.find(item => item.value == val);
        return item ? item.name : '';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .r_dropDownScreen {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
  }

  .tabBox {
    background: #fff;
    padding: 30px;
    width: 210mm;
  }

  .noteBox {
    width: 210mm;
    padding: 20px 10px 0 0;
  }

  .noteTitle {
    margin-bottom: 20px;
    text-align: center;
    font-size: 24px;
    font-weight: bold !important;
    font-family: STSong;
  }

  .noteBox p {
    margin-bottom: 15px;
    line-height: 1.5em;
    font-size: 16px;
    color: #000;
    font-family: "宋体";
  }

  .tabtop13 td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .font-center {
    text-align: center;
    font-size: 16px;
    padding: 3px 0;
  }

  .titfont {
    font-family: 微软雅黑;
    font-weight: bold;
  }

  .printBox table {
    border: #000 2px solid;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: #000 1px solid;
    height: 25px;
  }

  .checkBox {
    justify-content: center;
  }

  .ensure {
    padding-left: 2em;
    font-size: 16px;
    color: #000;
    padding-top: 5px;
  }

  .d1 {
    font-size: 16px;
    color: #000;
    padding-top: 5px;
    padding-left: 10px;
    margin-bottom: 30px;
  }

  .d2 {
    font-size: 16px;
    color: #000;
    padding: 10px 30px 5px 5px;
  }

  .signatureBox {
    font-size: 16px;
    justify-content: end;
    display: flex;
    margin-top: 10px;
    color: #000;
  }

  .signatureTips {
    margin-top: 10px;
    font-size: 14px;
    justify-content: end;
    display: flex;
    color: #000;
  }

  .year {
    margin-left: 50px;
  }

  .photoBox {
    text-align: center;
    font-size: 18px;
  }

  .f_btns {
    display: flex;
    justify-content: flex-end;
  }

  .e_txt_box {
    font-size: 14px;
    color: #409eff;
    text-align: right;
  }

  .com_empty {
    width: 100%;
    padding: 10px;
    color: #666;
    font-size: 14px;
    text-align: center;
  }

  /* 导入样式 */
  .import_basic_box {
    display: flex;
    flex-wrap: wrap;
  }

  .form-item input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ccc;
    padding-left: 14px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 10px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput,
  #templateInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  /* 这是主要的，文件上传按钮的样式 */
  .file-btn {
    display: inline-block;
    width: 54px;
    height: 31px;
    background: #fff;
    border: 1px solid #ccc;
    /* border-radius:2px; */
    text-align: center !important;
    line-height: 32px;
    color: #333333;
    /* position: relative;
  top: 5px;
  left: 0; */
    margin-left: 8px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 5px;
  }

  @media print {
    .tabBox {
      width: 100%;
      max-width: 210mm;
      min-height: 297mm;
      margin: 0 auto;
      padding: 5mm;
      box-sizing: border-box;
    }
  }

  .invoiceTable {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
  }

  .invoiceTable tr {
    page-break-inside: avoid;
  }

  .invoiceTable td,
  .invoiceTable th {
    font-size: 12px;
    line-height: 1.5em;
    padding: 4px;
  }

  .noteBox {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .noteBot {
    margin-top: 20px;
    font-size: 24px;
    font-weight: 600;
    padding: 0 150px 0 10px;
    font-family: "STSong";
  }

  .fieldsBox {
    max-height: 200px;
    overflow-y: scroll;
  }
</style>
<style>
  .page_empRosterPerson .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_empRosterPerson .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_empRosterPerson .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_empRosterPerson .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_empRosterPerson .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_empRosterPerson .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_empRosterPerson .declareForm .el-form-item__error {
    top: 34px;
  }

  /* el-table表格固定列el-table__fixed导致滚动条无法拖动 */
  .page_empRosterPerson .el-table__fixed {
    height: calc(100% - 18px) !important;
  }

  /* 用于消除固定列下方的伪元素边框线 */
  .page_empRosterPerson .el-table__fixed:before {
    height: 0px;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .page_empRosterPerson .checkBox .el-checkbox__label {
    font-size: 12px;
    font-family: 微软雅黑;
    padding-top: 3px;
  }

  .page_empRosterPerson .checkBox .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #000 !important;
  }

  .page_empRosterPerson .checkBox .el-checkbox__input.is-checked .el-checkbox__inner,
  .page_empRosterPerson .checkBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #000 !important;
    border-color: #000 !important;
  }

  .page_empRosterPerson .res_dialog .el-dialog__body {
    padding: 5px 20px 20px 20px;
  }

  .page_empRosterPerson .dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .page_empRosterPerson .dia_label_box .el-checkbox.is-bordered.is-checked,
  .page_empRosterPerson .dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #19BD92;
  }

  .page_empRosterPerson .dia_label_box {
    max-height: 400px;
    overflow-y: auto;
  }

  .page_empRosterPerson .dia_label_box .el-checkbox {
    border: 1px solid #ddd;
    padding: 2px 3px;
    border-radius: 3px;
    height: auto;
    margin: 5px 20px 0 0;
  }

  .page_empRosterPerson .re_table.el-table .cell {
    padding: 0 5px;
  }

  .page_empRosterPerson .re_table.el-table .el-table__cell {
    padding: 3px 0;
  }

  .com_import_box .storageInput .el-input--small .el-input__inner,
  .com_import_box .storageInput .el-input--small {
    width: 240px;
  }

  .r_act_item .com_btn {
    background-color: #19bd92;
    border-color: #19bd92;
    color: #fff;
  }

  .page_empRosterPerson .warning-row {
    background: rgb(255, 199, 206);
  }

  .page_empRosterPerson .el-card__header {
    padding: 12px 20px;
  }

  .page_empRosterPerson .re_act_box .el-button {
    padding: 4px 8px;
  }

  .page_empRosterPerson .el-table__fixed-body-wrapper {
    border: 0;
  }

  .page_empRosterPerson .el-table__fixed-body-wrapper {
    top: 45px !important;
  }
</style>